var New = "New";
var EN_TRANSLATION = {
  "Buy Now": "Buy Now",
  "Coming Soon": "Coming Soon",
  "Learn More": "Learn More",
  New: New,
  "Start Trial": "Start Trial",
  "_8PoEGen1.description": "An 8-port, Layer 2 PoE switch with a silent, fanless cooling system",
  "_8PoEGen1.poeOutput": "Up to PoE",
  "_8PoESFPGen1.description": "An 8-port, Layer 2 PoE switch with a fanless cooling system",
  "acInWall.description": "An entry point to seamless WiFi installations",
  "acInWall.wifiTechnology": "WiFi 5\nDual-radio 2.4 / 5 GHz\n4 spatial streams",
  "acMesh.antennaType.omnidirectional": "Omnidirectional*",
  "acMesh.description": "Compact with external antenna support for directional coverage",
  "acMesh.notes.externalAntenna": "*External directional antenna sold separately.",
  "acMesh.wifiTechnology": "WiFi 5\nDual-radio 2.4 / 5 GHz\n4 spatial streams",
  "acMeshProfessional.description": "Extended signal range tailored for outdoor coverage",
  "acMeshProfessional.wifiTechnology": "WiFi 5\nDual-radio 2.4 / 5 GHz\n6 spatial streams",
  "accessHub.description": "Entry and exit control for a single door",
  "accessHub.inputTerminals": "(1) Request to exit\n(1) Request to enter\n(1) Remote release\n(1) Door position sensor",
  "accessHub.outputRelays": "(2) Lock terminals (12V and dry)\n(2) AUX for chimes, sirens, or door openers",
  "accessHub.poePorts": "(3) PoE for access readers\nand cameras",
  "accessPowerMethod.title": "Power Method",
  "aggregation.description": "Designed for 10G SFP+ connections",
  "aggregation.title": "Aggregation",
  "ai360.description": "Panoramic coverage with digital PTZ control",
  "ai360.fieldOfView": "360° panoramic",
  "ai360.outdoorReady": "IPX4 (While covered)",
  "aiBullet.description": "An entry point to advanced AI features",
  "aiBullet.fieldOfView": "84.7° horizontal",
  "aiDSLR.description": "Unmatched image quality and low-light performance",
  "aiDSLR.fieldOfView": "52° or 21.6° horizontal,\nbased on lens",
  "aiDome.description": "All-weather, vandal-proof 4K PoE dome camera",
  "aiDome.fieldOfView": "109.9° horizontal",
  "aiDome.nightVision": "40 m (131 ft)",
  "aiDslr.outdoorReady": "IPX5 (With the outdoor case)",
  "aiLpr.description.1": "Optimized for recognizing license plates",
  "aiLpr.fieldOfView": "109.9° to 35° horizontal, based on zoom",
  "aiLpr.nightVision": "15 m (50 ft)",
  "aiLpr.opticalZoom": "3x*\n*Optimized for night time and high vehicle speeds",
  "aiPro.description": "Incredible resolution with long-range advanced AI",
  "aiPro.fieldOfView": "109.9° to 34.9° horizontal,\nbased on zoom",
  "aiPro.nightVision": "25 m (82 ft)\nup to 40 m (131 ft)*\n*With Vision Enhancer",
  "aiPtz.description": "Industrial-grade 4K PoE++ PTZ camera with enhanced AI capabilities",
  "aiPtz.fov": "64° to 3° horizontal,\nbased on zoom",
  "aiPtz.opticalZoom": "22x optical zoom",
  "aiPtzIndustrial.footnote.1": "Available May 2025 in Canada, Europe, UK",
  "aiPtzPrecision.comingSoonButtonText": "Coming Q3 2025",
  "aiPtzPrecision.description": "Industrial-grade camera, enhanced AI capabilities, LiDAR technology",
  "aiPtzPrecision.fov": "61.7° to 2.1° horizontal,\nbased on zoom",
  "aiPtzPrecision.opticalZoom": "31x optical zoom\nLiDAR for faster Auto Focus.",
  "aiRecognition.title": "AI Recognition",
  "aiTurret.description": "All-weather, vandal-proof 4K PoE+ turret camera",
  "aiTurret.fieldOfView": "109.9° horizontal",
  "aiTurret.nightVision": "40 m (131 ft)",
  "airFiber11.description": "Low or High Band",
  "airFiber11.dimensions": "327 x 112 x 86 mm",
  "airFiber11.frequency": "11 GHz",
  "airFiber11.linkRange": "300+ km",
  "airFiber11.networkInterface": "(1) GbE RJ45 port\n(1) 10/100 MbE RJ45 port",
  "airFiber11.swivelPowerMethod": "Passive PoE 4-pairs\nTerminal block direct-wire",
  "airFiber11.swivelSpectralEfficiency": "17.7 bps/Hz",
  "airFiber11.throughput": "1.2+ Gbps",
  "airFiber11.windLoading": "1538 N @ 200 km/h",
  "airFiber24.description": "Standard Range",
  "airFiber24.dimensions": "649 x 426 x 303 mm",
  "airFiber24.frequency": "24 GHz",
  "airFiber24.linkRange": "13+ km",
  "airFiber24.networkInterface": "(1) GbE RJ45 port\n(1) 10/100 MbE RJ45 port",
  "airFiber24.swivelPowerMethod": "Passive PoE 4-pairs",
  "airFiber24.swivelSpectralEfficiency": "14.1 bps/Hz",
  "airFiber24.throughput": "1.5+ Gbps",
  "airFiber24.windLoading": "480 N @ 200 km/h",
  "airFiber24HiDensity.description": "Long-Range Client",
  "airFiber24HiDensity.dimensions": "593 x 768 x 370 mm",
  "airFiber24HiDensity.frequency": "24 GHz",
  "airFiber24HiDensity.linkRange": "20+ km",
  "airFiber24HiDensity.networkInterface": "(1) GbE RJ45 port\n(1) 10/100 MbE RJ45 port",
  "airFiber24HiDensity.swivelPowerMethod": "Passive PoE 4-pairs",
  "airFiber24HiDensity.swivelSpectralEfficiency": "14.1 bps/Hz",
  "airFiber24HiDensity.throughput": "2+ Gbps",
  "airFiber24HiDensity.windLoading": "770 N @ 200 km/h",
  "airFiber2X.description": "High-Performance",
  "airFiber2X.dimensions": "224 x 82 x 48 mm",
  "airFiber2X.linkRange": "200+ km",
  "airFiber2X.networkInterface": "(1) GbE RJ45 port\n(1) 10/100 MbE RJ45 port",
  "airFiber2X.swivelPowerMethod": "Passive PoE 4-pairs\nPassive PoE 2-pairs",
  "airFiber2X.throughput": "680+ Mbps",
  "airFiber37dBiMonsterDish.antennaGain": "4.9 GHz: 34 dBi\n5.2-5.8 Ghz: 35-37 dBi",
  "airFiber37dBiMonsterDish.dimensions": "Ø1600 x 820 mm",
  "airFiber37dBiMonsterDish.weight": "Without Mount: 19 kg\nWith Mount: 40.9 kg",
  "airFiber37dBiMonsterDish.windLoading": "6385 N @ 200 km/h",
  "airFiber5.description": "Mid or High Band",
  "airFiber5.dimensions": "938.4 x 468.4 x 281.4 mm",
  "airFiber5.linkRange": "100+ km",
  "airFiber5.networkInterface": "(1) GbE RJ45 port\n(1) 10/100 MbE RJ45 port",
  "airFiber5.swivelPowerMethod": "Passive PoE 4-pairs",
  "airFiber5.swivelSpectralEfficiency": "17.7 bps/Hz",
  "airFiber5.throughput": "1.2+ Gbps",
  "airFiber5.windLoading": "863 N @ 200 km/h",
  "airFiber5XHD.description": "High-Density",
  "airFiber5XHD.dimensions": "224 x 82 x 48 mm",
  "airFiber5XHD.linkRange": "100+ km",
  "airFiber5XHD.networkInterface": "(2) GbE RJ45 ports",
  "airFiber5XHD.swivelPackets": "2+ Mpps",
  "airFiber5XHD.swivelPowerMethod": "Passive PoE 4-pairs\nPassive PoE 2-pairs",
  "airFiber5XHD.swivelSpectralEfficiency": "21.2 bps/Hz",
  "airFiber5XHD.throughput": "1000+ Mbps",
  "airFiber60HD.description": "Top-Speed",
  "airFiber60LongRange.description": "Long-range, Wave-compatible 60 GHz PtMP client",
  "airFiber60XG.description": "Top-Speed",
  "airFiber60XG.notes.1": "*Max. throughput: 800 Mbps",
  "airFiber60XTremeRange.description": "Ultra Long-Range",
  "airFiber60XTremeRange.notes.1": "*Max. throughput: 800 Mbps",
  "airFiberX23dBiSlant45.dimensions": "378 x 378 x 290 mm",
  "airFiberX23dBiSlant45.weight": "With Mount: 3.4 kg",
  "airFiberX23dBiSlant45.windLoading": "190 N @ 200 km/h",
  "airFiberX24dBiSlant45.dimensions": "650 x 650 x 295 mm",
  "airFiberX24dBiSlant45.windLoading": "787 N @ 200 km/h",
  "airFiberX30dBiSlant45.dimensions": "650 x 650 x 386 mm",
  "airFiberX30dBiSlant45.weight": "With Mount: 7.4 kg",
  "airFiberX30dBiSlant45.windLoading": "790 N @ 200 km/h",
  "airFiberX34dBiSlant45.dimensions": "1050 x 1050 x 421 mm",
  "airFiberX34dBiSlant45.weight": "With Mount: 13.5 kg",
  "airFiberX34dBiSlant45.windLoading": "1,779 N @ 200 km/h",
  "airMAX24GHz10dBiOmni.description": "2x2 dual-polarity MIMO",
  "airMAX24GHz10dBiOmni.dimensions": "1030 x 122 x 84 mm",
  "airMAX24GHz10dBiOmni.elevationBeamwidth": "12°",
  "airMAX24GHz10dBiOmni.radiusCoverage": "360°",
  "airMAX24GHz10dBiOmni.windLoading": "62.3 N @ 160 km/h",
  "airMAX24GHz13dBiOmni.description": "2x2 dual-polarity MIMO",
  "airMAX24GHz13dBiOmni.dimensions": "1390 x 122 x 105 mm",
  "airMAX24GHz13dBiOmni.elevationBeamwidth": "7°",
  "airMAX24GHz13dBiOmni.radiusCoverage": "360°",
  "airMAX24GHz13dBiOmni.windLoading": "71.2 N @ 160 km/h",
  "airMAX24GHz15dBi120Sector.antennaGain": "15.0 - 16.0 dBi",
  "airMAX24GHz15dBi120Sector.description": "AM-2G15-120",
  "airMAX24GHz15dBi120Sector.dimensions": "700 x 145 x 93 mm",
  "airMAX24GHz15dBi120Sector.radiusCoverage": "120°",
  "airMAX24GHz15dBi120Sector.windLoading": "107 N @ 160 km/h",
  "airMAX24GHz16dBi90Sector.antennaGain": "16.0 - 17.0 dBi",
  "airMAX24GHz16dBi90Sector.description": "AM-2G16-90",
  "airMAX24GHz16dBi90Sector.dimensions": "700 x 145 x 79 mm",
  "airMAX24GHz16dBi90Sector.radiusCoverage": "90°",
  "airMAX24GHz16dBi90Sector.windLoading": "85 N @ 160 km/h",
  "airMAX30dBiRocketDishLW.dimensions": "650 x 650 x 386 mm",
  "airMAX30dBiRocketDishLW.windLoading": "790 N @ 200 km/h",
  "airMAX5GHz10dBiOmni.description": "2x2 dual-polarity MIMO",
  "airMAX5GHz10dBiOmni.dimensions": "582 x 90 x 65 mm",
  "airMAX5GHz10dBiOmni.elevationBeamwidth": "12°",
  "airMAX5GHz10dBiOmni.radiusCoverage": "360°",
  "airMAX5GHz10dBiOmni.weight": "680 g",
  "airMAX5GHz10dBiOmni.windLoading": "44.5 N @ 160 km/h",
  "airMAX5GHz13dBiOmni.description": "2x2 dual-polarity MIMO",
  "airMAX5GHz13dBiOmni.dimensions": "799 x 90 x 65 mm",
  "airMAX5GHz13dBiOmni.elevationBeamwidth": "7°",
  "airMAX5GHz13dBiOmni.radiusCoverage": "360°",
  "airMAX5GHz13dBiOmni.weight": "820 g",
  "airMAX5GHz13dBiOmni.windLoading": "84.52 N @ 200 km/h",
  "airMAX5GHz16dBi120Sector.antennaGain": "15.0 - 16.0 dBi",
  "airMAX5GHz16dBi120Sector.description": "AM-5G16-120",
  "airMAX5GHz16dBi120Sector.dimensions": "367 x 63 x 41 mm",
  "airMAX5GHz16dBi120Sector.radiusCoverage": "120°",
  "airMAX5GHz16dBi120Sector.windLoading": "26 N @ 160 km/h",
  "airMAX5GHz17dBi90Sector.antennaGain": "16.1 - 17.1 dBi",
  "airMAX5GHz17dBi90Sector.description": "AM-5G17-90",
  "airMAX5GHz17dBi90Sector.dimensions": "367 x 63 x 41 mm",
  "airMAX5GHz17dBi90Sector.radiusCoverage": "90°",
  "airMAX5GHz17dBi90Sector.windLoading": "26 N @ 160 km/h",
  "airMAX5GHz19dBi120Sector.antennaGain": "18.6 - 19.1 dBi",
  "airMAX5GHz19dBi120Sector.description": "AM-5G19-120",
  "airMAX5GHz19dBi120Sector.dimensions": "700 x 135 x 73 mm",
  "airMAX5GHz19dBi120Sector.radiusCoverage": "120°",
  "airMAX5GHz19dBi120Sector.windLoading": "89 N @ 160 km/h",
  "airMAX5GHz20dBi90Sector.antennaGain": "19.4 - 20.3 dBi",
  "airMAX5GHz20dBi90Sector.description": "AM-5G20-90",
  "airMAX5GHz20dBi90Sector.dimensions": "700 x 135 x 70 mm",
  "airMAX5GHz20dBi90Sector.radiusCoverage": "390°",
  "airMAX5GHz20dBi90Sector.windLoading": "115 N @ 160 km/h",
  "airMAX900MHz13dBi120Sector.antennaGain": "13.2 - 13.8 dBi",
  "airMAX900MHz13dBi120Sector.description": "AM-9M13-120",
  "airMAX900MHz13dBi120Sector.dimensions": "1290 x 290 x 134 mm",
  "airMAX900MHz13dBi120Sector.frequency": "900 MHz",
  "airMAX900MHz13dBi120Sector.radiusCoverage": "120°",
  "airMAX900MHz13dBi120Sector.windLoading": "422.6 N @ 160 km/h",
  "airMAXAC30dBiRocketDish.antennaGain": "4.9 GHz: 26 dBi\n5 - 5.9 GHz: 30 dBi",
  "airMAXAC30dBiRocketDish.dimensions": "650 x 650 x 304 mm",
  "airMAXAC30dBiRocketDish.windLoading": "787 N @ 200 km/h",
  "airMAXAC31dBiRocketDish.dimensions": "748 x 748 x 349 mm",
  "airMAXAC31dBiRocketDish.weight": "With Mount: 7.6 kg",
  "airMAXAC31dBiRocketDish.windLoading": "1,028 N @ 200 km/h",
  "airMAXAC34dBiRocketDish.antennaGain": "4.9 GHz: 30 dBi\n5 - 5.8 GHz: 34 dBi",
  "airMAXAC34dBiRocketDish.dimensions": "1050 x 1050 x 421 mm",
  "airMAXAC34dBiRocketDish.windLoading": "1,779 N @ 200 km/h",
  "airMAXAC5GHz21dBi60Sector.description": "AM-5AC21-60",
  "airMAXAC5GHz21dBi60Sector.dimensions": "750 x 173 x 78 mm",
  "airMAXAC5GHz21dBi60Sector.radiusCoverage": "60°",
  "airMAXAC5GHz21dBi60Sector.windLoading": "391 N @ 200 km/h",
  "airMAXAC5GHz22dBi45Sector.description": "AM-5AC22-45",
  "airMAXAC5GHz22dBi45Sector.dimensions": "750 x 215 x 94 mm",
  "airMAXAC5GHz22dBi45Sector.radiusCoverage": "45°",
  "airMAXAC5GHz22dBi45Sector.windLoading": "347 N @ 200 km/h",
  "airMAXSector24GHzTitanium.antennaGain": "17 dBi @ 60°\n16 dBi @ 90°\n15 dBi @ 120°",
  "airMAXSector24GHzTitanium.description": "AM-V2G-Ti",
  "airMAXSector24GHzTitanium.dimensions": "773 x 372 x 120 mm",
  "airMAXSector24GHzTitanium.radiusCoverage": "60°/ 90°/ 120°",
  "airMAXSector24GHzTitanium.weight": "With Mount: 6.4 kg",
  "airMAXSector24GHzTitanium.windLoading": "640.5 N@ 200 km/h",
  "airMaxGigaBeam..description": "High-Gain",
  "airMaxGigaBeamLongRange.description": "High-Gain",
  "airMaxGigaBeamPlus.description": "High-Gain",
  "airPRISM3x30HDSector.description": "AP-5AC-90-HD",
  "airPRISM3x30HDSector.dimensions": "322.6 x 201.5 x 1300 mm",
  "airPRISM3x30HDSector.radiusCoverage": "3 x 30°",
  "airPRISM3x30HDSector.weight": "With Mount: 13.1 kg",
  "airPRISM3x30HDSector.windLoading": "534 N @ 200 km/h",
  "alignment.title": "Alignment",
  "androidAppMode.title": "Android App Mode",
  "androidAppMode.tooltip": "Run Android apps on the Connect Display to deliver customizable interactive experiences. <a href=\"https://help.ui.com/hc/en-us/articles/10775946997655\">Learn more.</a>",
  "antennaGain.title": "Antenna Gain",
  "antennaType.directional": "Directional",
  "antennaType.omnidirectional": "Omnidirectional",
  "antennaType.selectableDirectional": "Selectable directional",
  "antennaType.title": "Antenna Type",
  "appleTouchPassAccess.title": "Apple Touch Pass Access",
  "aux.title": "AUX terminals for chimes, sirens, or door openers",
  "availability.title": "Availability",
  "backupRadio.title": "Backup Radio",
  "baseStationXG.description": "1500+ client devices for high-density environments like stadiums and arenas",
  "baseStationXG.notes.1": "*Selectable directional beamforming antenna (15 dBi, 50° or 10 dBi, 90°) allows for cell size optimization.",
  "baseStationXG.wifiCoverage": "Directional: 465 m² (5,000 ft²) open space",
  "baseStationXG.wifiTechnology": "WiFi 5\nTri-radio 5 GHz\n12 spatial streams",
  "baseStationXg.antennaType.selectableDirectional": "Selectable directional*",
  "batteryFull.title": "Battery backup",
  "bluetoothSupport.title": "Bluetooth Support",
  "bridge.title": "Bridge & Router Mode",
  "buildingBridge.alignment": "Built-in LED indicators",
  "buildingBridge.description": "High-performance wireless point-to-point bridge",
  "buildingBridge.maximumRange": "500 m (1,640 ft)",
  "buildingBridge.radios": "60 GHz with 5 GHz backup",
  "buildingBridge.throughput": "Up to 1.8 Gbps",
  "buildingBridgeXG.alignment": "Built-in LED indicators",
  "buildingBridgeXG.description": "Fiber-like performance without the wire",
  "buildingBridgeXG.maximumRange": "500 m (1,640 ft)",
  "buildingBridgeXG.radios": "60 GHz with 5 GHz backup",
  "buildingBridgeXG.throughput": "Up to 6 Gbps",
  "builtInFloodlight.title": "Built-In Floodlight",
  "builtin128GbSsd.title": "Built-in 128 GB SSD",
  "bullet.title": "Bullet",
  "cameraAudio.title": "Audio",
  "cameraReader.title": "Camera",
  "cameraResolution.title": "Resolution",
  "carrierSupport.title": "Carrier Support",
  "cellular.title": "Cellular",
  "chargingConnector.title": "Charging Connector",
  "clientCapacity.title": "Client Capacity",
  "clientDevices.title": "Client Devices",
  "cloudKeyEnterprise.deployment": "On-premises",
  "cloudKeyEnterprise.description": "Rack-mount UniFi Console designed for massive-scale networks",
  "cloudKeyEnterprise.formFactor": "Rack",
  "cloudKeyG2Plus.deployment": "On-premises",
  "cloudKeyG2Plus.description": "Compact UniFi Console ideal for entry-level deployments",
  "cloudKeyG2Plus.description.videoRecorders": "Flexible solution for entry-level deployments",
  "cloudKeyG2Plus.formFactor": "Desktop, with optional Table Stand and Rack Mount accessories",
  "cloudKeyG2Plus.storageCapacity": "(1) 2.5\" drive bay with 1 TB pre‑installed",
  "cloudKeyG2Plus.title": "CloudKey+",
  "commons.badge.kitIncluded": "Kit Included",
  "commons.cameraAudio.microphone": "Microphone",
  "commons.cameraAudio.twoWayAudio": "Two-way audio",
  "commons.comingSoon.availableMay2025": "Available May 2025",
  "commons.connectivity.ethernet": "Ethernet",
  "commons.connectivity.ethernetWiFi": "Ethernet\nWiFi",
  "commons.connectivity.wiFiEthernet": "WiFi\nEthernet",
  "commons.display.5touchscreen": "5\" touchscreen",
  "commons.display.7touchscreen": "7\" touchscreen",
  "commons.emptyColumn.description": "Select from Above",
  "commons.formFactor.desktop": "Desktop",
  "commons.linkRange.15+km": "15+ km",
  "commons.mounting.ceilingWall": "Ceiling\nWall",
  "commons.mounting.desktop": "Desktop",
  "commons.mounting.desktopWall": "Desktop\nWall",
  "commons.mounting.rack": "Rack",
  "commons.mounting.rackMount1U": "Rack mount (1U)",
  "commons.mounting.wall": "Wall",
  "commons.mounting.wallPole": "Wall\nPole",
  "commons.networkInterface.1GbeRj45Port": "(1) GbE RJ45 port",
  "commons.poeOutput.upToPoe+": "Up to PoE+",
  "commons.poeOutput.upToPoe++": "Up to PoE++",
  "commons.powerMethod.acPower": "AC Power",
  "commons.powerMethod.passivePoe2Pair": "Passive PoE 2-pair",
  "commons.powerMethod.poeAndUsbCAdapter": "PoE\nUSB-C Adapter",
  "commons.powerMethodPoe.poe": "PoE",
  "commons.powerRedundancy.dcPowerBackup": "DC Power Backup",
  "commons.powerRedundancy.dualHotSwappablePsus": "Dual hot-swappable PSUs",
  "commons.powerRedundancy.unifiPowerBackupReady": "UniFi Power Backup ready",
  "commons.productList.button.active": "Remove",
  "commons.productList.button.inactive": "Compare",
  "commons.productList.series": "Series",
  "commons.scrollButton.left": "Scroll products left",
  "commons.scrollButton.right": "Scroll products right",
  "commons.speakerphone.highPerformance": "High-performance",
  "commons.speed.upTo10Gbps": "Up to 10 Gbps",
  "commons.speed.upTo2_5Gbps": "Up to 2.5 Gbps",
  "commons.switchingTechnology.layer2": "Layer 2",
  "commons.switchingTechnology.layer3": "Layer 3",
  "commons.uplinkSpeed.upTo25Gbps": "Up to 25 Gbps",
  "compact.title": "Compact",
  "connectDisplay.connectivity": "Ethernet",
  "connectDisplay.deployment": "Standalone touchscreen display",
  "connectDisplay.description": "PoE++ touchscreen designed for interactive digital experiences",
  "connectDisplay.videoContentSupport": "Up to Full HD / 60 FPS",
  "connectDisplayEn.title": "Connect Display",
  "connectedDevices.title": "Connected Devices",
  "connectivity.title": "Connectivity",
  "coverage.title": "Coverage",
  "customization.title": "Customization",
  "dataPlan.title": "Included Data Plan",
  "dataProtection.title": "Data Protection",
  "dataProtection.tooltip": "Automatically protect your data from drive failures with RAID data redundancy and Hot Spare support.\n<a href=\"https://help.ui.com/hc/en-us/articles/12395353544727-UniFi-Protect-Storage-Protection-and-Data-Redundancy\">Learn more.</a>",
  "dcPowerOutput.title": "DC Power Output",
  "dedicatedSpectral.title": "Dedicated Spectral Scanning Radio",
  "dedicatedSpectralScanningEngine.title": "Dedicated Spectral Scanning Engine",
  "dedicatedWiFi.title": "Dedicated WiFi Management Radio",
  "deployment.title": "Deployment",
  "digitalSignageMode.title": "Digital Signage Mode",
  "digitalSignageMode.tooltip": "Easily display and manage media content with UniFi Connect, including customizable playlists and dynamic layouts. <a href=\"https://help.ui.com/hc/en-us/articles/23407622707735-UniFi-Connect-Present-Media-Content\">Learn more.</a>",
  "digitalSignageSupport.title": "Digital Signage Support",
  "digitalSignageSupport.tooltip": "Easily display and manage media content with UniFi Connect, including customizable playlists and dynamic layouts. <a href='https://help.ui.com/hc/en-us/articles/23407622707735-UniFi-Connect-Present-Media-Content'>Learn more.</a>",
  "dimensions.title": "Dimensions",
  "directory.title": "Directory",
  "display.title": "Display",
  "domeTurret.title": "Dome & Turret",
  "doorAccessSupport.title": "Door Access\nSupport",
  "doorAccessSupport.tooltip": "Run the UniFi Access Application to manage both camera security and physical access with a single device.",
  "doorHub.description": "Entry and exit control for a single door",
  "doorHub.inputTerminals": "(1) Motion sensor\n(1) Exit button\n(1) Door position sensor\n(1) Emergency",
  "doorHub.outputRelays": "(2) Lock terminals (12V and dry)\n(1) AUX for door operator (dry)\n(1) AUX for siren/chime (12V)",
  "doorHub.poePorts": "(4) PoE for access readers and cameras",
  "doorHubMini.description": "Compact Access Control Hub for a single door",
  "doorHubMini.inputTerminals": "(1) Request to exit\n(1) Door position sensor",
  "doorHubMini.outputRelays": "(1) Lock terminal (12V and dry)",
  "doorHubMini.poePorts": "(2) PoE for access readers and cameras",
  "downlinkSpeed.title": "Downlink Speed",
  "driveHotSwap.title": "Drive Hot-Swap",
  "driveHotSwap.tooltip": "Add drives to increase storage or replace at-risk drives at any time without data loss or downtime.",
  "dyingGaspSupport.title": "Dying Gasp Support",
  "e7.description": "10G PoE uplink and a redundant GbE port for high availability in critical enterprise environments",
  "e7.mounting": "Wall\nCeiling",
  "e7.mounting.1": "Wall\nCeiling*",
  "e7.notes.1": "***Compatible with UniFi Pro Mounting",
  "e7.notes.2": "*Compatible with UniFi Pro Mounting",
  "e7.wifiCoverage": "185 m² (2,000 ft²)",
  "e7.wifiTechnology": "WiFi 7\nTri-radio 2.4 / 5 / 6 GHz\n10 spatial streams",
  "e7Audience.antennaType.selectableDirectional": "Selectable directional**",
  "e7Audience.description": "1500+ client devices for high-density environments like stadiums and arenas, with 6 GHz support",
  "e7Audience.description.megaCapacity": "1500+ client devices for high-density venues with WiFi 7 and 6 GHz support",
  "e7Audience.notes.1": "*US & CA version only.",
  "e7Audience.notes.2": "**Selectable directional beamforming antenna (15 dBi, 50° or 10 dBi, 90°) allows for cell size optimization",
  "e7Audience.notes.megaCapacity.1": "*Selectable directional beamforming antenna (15 dBi, 50° or 10 dBi, 90°) allows for cell size optimization",
  "e7Audience.notes.megaCapacity.2": "**US & CA version only.",
  "e7Audience.notes.megaCapacity.3": "***Coming soon.",
  "e7Audience.wifiCoverage": "Directional: 465+ m² (5,000+ ft²) open space",
  "e7Audience.wifiTechnology": "WiFi 7\nTri-radio 5 / 6 GHz\n12 spatial streams",
  "e7Campus.description": "Outdoor rugged IP67 design and PRISM™ active RF filtering technology - perfect for campuses",
  "e7Campus.mounting": "Wall\nPole\nCeiling",
  "e7Campus.note.1": "*US & CA version only.",
  "e7Campus.wifiCoverage": "Directional: 465 m² (5,000 ft²) open space",
  "e7Campus.wifiTechnology": "WiFi 7\nTri-radio 2.4 / 5 / 6* GHz\n10 spatial streams",
  "edgePointR6.description": "EP-R6",
  "edgePointR8.description": "EP-R8",
  "edgePointS16.description": "EP-S16",
  "edgeRouter10x.description": "ER-10X",
  "edgeRouter12.description": "ER-12",
  "edgeRouter12.notes.1": "*8 ports only",
  "edgeRouter12p.description": "ER-12P",
  "edgeRouter4.description": "ER-4",
  "edgeRouter6Poe.description": "ER-6P",
  "edgeRouterInfinity.description": "ER-8-XG",
  "edgeRouterX.description": "ER-X",
  "edgeRouterXSfp.description": "ER-X-SFP",
  "edgeSwitch10x.description": "ES-10X",
  "edgeSwitch10xp.description": "ES-10XP",
  "edgeSwitch12f.description": "ES-12F",
  "edgeSwitch16poe150.description": "ES-16-150W",
  "edgeSwitch16xg.description": "ES-16-XG",
  "edgeSwitch16xp.description": "ES-16XP",
  "edgeSwitch18x.description": "ES-18X",
  "edgeSwitch24lite.description": "ES-24-Lite",
  "edgeSwitch24poe.description": "ES-24-250W",
  "edgeSwitch24poe500.description": "ES-24-500W",
  "edgeSwitch48lite.description": "ES-48-Lite",
  "edgeSwitch48poe-750.description": "ES-48-750W",
  "edgeSwitch48poe.description": "ES-48-500W",
  "edgeSwitch5xp.description": "ES-5XP",
  "edgeSwitch8poe.description": "ES-8-150W",
  "efg.description": "Purpose-built for the most demanding networks",
  "efg.generalRedundancy": "Shadow Mode (VRRP) Gateway Failover\n(2) Hot-Swappable PSUs",
  "efg.note": "All networking interfaces are LAN/WAN remappable.",
  "efg.powerRedundancy": "Dual hot-swappable PSUs",
  "elevationBeamwidth.title": "Elevation Beamwidth",
  "elevatorHub.description": "Authorized entry to up to 18 floors using an in-elevator reader",
  "elevatorHub.inputTerminals": "(1) Emergency\n(1) Car position (5-bit)\n(1) Car status: up/down/stop/full\n(1) Door status: open/close",
  "elevatorHub.outputRelays": "(18) Relays to support 18 floors",
  "elevatorHub.poePorts": "(4) PoE for access readers\nand cameras",
  "elevatorStarterKit.description": "Authorized entry to up to 18 floors using an in-elevator reader",
  "elevatorStarterKit.includedAccessories": "(1) PoE over 2-Wire Retrofit Extenders\n(10) Access Cards",
  "elevatorStarterKit.includedHub": "(1) Elevator Hub",
  "elevatorStarterKit.includedReaders": "(1) G2 Reader",
  "enhancedDetections.title": "Enhanced Detection\nAccuracy & Range",
  "enterprise24PoE.description": "PoE+ output at up to 2.5 GbE speeds",
  "enterprise48PoE.description": "2.5 GbE ports with PoE+ output",
  "enterprise8PoE.description": "2.5 GbE ports with PoE+ output",
  "enterpriseAccessHub.description": "Entry and exit control for up to eight readers and doors, with battery backup support",
  "enterpriseAccessHub.inputTerminals": "(8) Request to exit\n(8) Door position sensor\n(1) Emergency",
  "enterpriseAccessHub.outputRelays": "(8) Lock terminals (12V and dry)\n(4) AUX for chimes, sirens, or door openers",
  "enterpriseAccessHub.poePorts": "(8) PoE for access readers\nand cameras",
  "enterpriseAccessHub.powerRedundancy": "(1) Battery backup input\n(32-48V DC)",
  "enterpriseCampus24PoE.description": "High-capacity 10 GbE ports with PoE+++ output",
  "enterpriseCampus48PoE.description": "High-capacity 10 GbE ports with PoE+++ output",
  "enterpriseCampusAggregation.description": "High-density 100G QSFP28 / 25G SFP28 aggregation switch",
  "enterpriseCampusAggregation.generalRedundancy": "Multi-Chassis Link Aggregation (MC-LAG)\nDual hot-swappable PSUs",
  "enterpriseXG24.description": "High-capacity 10 GbE RJ45 and 25G SFP28 connections",
  "envr.description": "Enterprise scalability and redundancy ideal for large organizations",
  "envr.formFactor": "3U rack-mountable",
  "envr.nvrPowerBackup": "(2) hot-swap PSUs for power redundancy",
  "envr.storageCapacity": "(16) 3.5\" drive bays",
  "ergonomicHandsetWithMuteButton.title": "Ergonomic Handset with Mute Button",
  "etherlighting.title": "Etherlighting™",
  "etherlighting.tooltip": "Etherlighting™ ports illuminate to indicate port location, speed/link, and native VLAN/network.",
  "evStationLite.connectivity": "UniFi WiFi Auto-Link\nEthernet",
  "evStationLite.description": "Compact station with flexible access methods designed for scalable deployment",
  "evStationLite.installation": "Hardwire",
  "evStationLite.mounting": "Wall\nPedestal**",
  "evStationLite.note.1": "*UniFi Access Application, Control Hub, and Reader required for NFC credential registration.",
  "evStationLite.note.2": "**EV Station Stand and Adapter sold separately.",
  "evStationLite.stationSecurityModes": "Open\nNFC Credential*\nUniFi Identity",
  "evStationPro.connectivity": "UniFi WiFi Auto-Link\nEthernet",
  "evStationPro.description": "Next-gen station with an ultra-bright touch display and payment terminal support",
  "evStationPro.installation": "Hardwire\nNEMA 14-50 Cable\nNEMA 6-50 Cable",
  "evStationPro.mounting": "Wall\nPedestal***",
  "evStationPro.note.1": "*EV Station Pro Payment Terminal sold separately.",
  "evStationPro.note.2": "**UniFi Access Application, Control Hub, and Reader required for NFC credential registration.",
  "evStationPro.note.3": "***EV Station Stand sold separately.",
  "evStationPro.stationSecurityModes": "Open\nQR Code\nNFC Credential**\nUniFi Identity\nCard / Contactless Payment",
  "exit.title": "Request-to-exit devices inputs",
  "express.description": "Impressively compact and WiFi integrated",
  "express.integratedWiFi": "Built-in WiFi 6 access point",
  "express.lanPorts": "(1) GbE RJ45",
  "express.mounting": "Desktop\nWall*",
  "express.notes": "*With Floating Mount accessory.",
  "express.unifiDevices": "4 additional",
  "express.wanPorts": "(1) GbE RJ45",
  "express7.description": "Mesh-scalable, super-compact 10G Cloud Gateway",
  "express7.integratedWiFi": "Built-in WiFi 7 access point with 6 GHz support",
  "express7.lanPorts": "(1) 2.5 GbE RJ45",
  "express7.notes": "*With Floating Mount accessory.",
  "express7.wanPorts": "(1) 10 GbE RJ45",
  "extendedRangeMode6Ghz.title": "6 GHz Extended Range Mode",
  "externalAntennaSupport.title": "External Antenna Support",
  "externalBatterySupport.title": "External Battery Support",
  "faceRecognition.title": "Face Recognition",
  "fiberInstant.bridge": "Bridge only",
  "fiberInstant.description": "GPON CPE in SFP module form factor",
  "fiberLoco.description": "Compact with extremely low power consumption",
  "fiberNanog.description": "Compact with an LED display for monitoring",
  "fiberOltXgs.description": "An eight-port optical line terminal that can deliver 10 Gbps uplink/downlink speeds to over 2,000 subscribers.",
  "fiberWifi.description": "Built-in WiFi 4 and a 4-port GbE switch",
  "fiberWifi.integratedSwitch": "4-port GbE switch",
  "fiberWifi6.description": "Built-in WiFi 6 and a 4-port GbE switch",
  "fiberXG.description": "Deliver 2.5 Gbps uplink/downlink speeds",
  "fiberXG.maxLinkRange": "20 km",
  "fiberXG.networkingInterface": "(1) XG-PON port\n(1) 2.5GbE RJ45 LAN port\nand 24V PoE in",
  "fiberXG.powerMethod": "USB-C 5V DC, 3A\n24V DC Passive PoE",
  "fiberXG.uplinkSpeed": "2.5 Gbps",
  "fiberXGS.description": "Deliver 10 Gbps uplink/downlink speeds",
  "fiberXGS.maxLinkRange": "20 km",
  "fiberXGS.networkingInterface": "(1) XGS-PON port\n(1) 10GbE RJ45 LAN port",
  "fiberXGS.powerMethod": "USB-C 5V DC, 3A",
  "fieldOfView.title": "Field of View",
  "fipsCompliance.title": "FIPS Compliance",
  "firewall.title": "Firewall and OSPF routing",
  "flex.description": "Weatherproof with PoE input support",
  "flex.mounting": "Desktop\nWall\nPole",
  "flex.poeAvailability": "Up to 46 W",
  "flex.powerMethod": "AC power or PoE to PoE++ input",
  "flex10GbE.description": "10 GbE speeds with PoE input support",
  "flex10GbE.mounting": "Desktop\nWall\nPole",
  "flex10GbE.powerMethod": "AC power or PoE+ input",
  "flex10GbE.uplinkSpeed": "Up to 10 Gbps",
  "flex2_5G.description": "Flexible 2.5G switch with 10 GbE RJ45/SFP+ uplink",
  "flex2_5G.mounting": "Desktop\nWall\nDIN rail",
  "flex2_5G.mounting.1": "Desktop\nWall\nDIN rail*",
  "flex2_5G.notes.1": "*DIN Rail Mount sold separately.",
  "flex2_5G.ports": "(8) 2.5 GbE RJ45",
  "flex2_5G.powerMethod": "AC power or PoE+ input",
  "flex2_5GPoE.description": "Flexible 2.5G PoE++ switch with 10 GbE RJ45/SFP+ uplink",
  "flex2_5GPoE.mounting": "Desktop\nWall\nDIN rail",
  "flex2_5GPoE.mounting.1": "Desktop\nWall\nDIN rail**",
  "flex2_5GPoE.mounting.overviewVariant": "Desktop\nWall\nDIN rail*",
  "flex2_5GPoE.notes.1": "*AC power or PoE+/PoE++/PoE+++ input required for PoE output.",
  "flex2_5GPoE.notes.2": "**DIN Rail Mount sold separately.",
  "flex2_5GPoE.notes.overviewVariant": "*DIN Rail Mount sold separately.",
  "flex2_5GPoE.poeAvailability": "Up to 196 W",
  "flex2_5GPoE.ports": "(8) 2.5 GbE RJ45",
  "flex2_5GPoE.powerMethod": "AC power or\nPoE+to PoE+++ input",
  "flex2_5GPoE.powerMethod.1": "AC power or\nPoE+ to PoE+++ input*",
  "flexMini.description": "Incredibly compact with PoE input support",
  "flexMini.powerMethod": "AC power or PoE input",
  "flexMini2_5G.description": "Compact 2.5G switch with PoE input support",
  "flexMini2_5G.downlinkSpeed": "2.5 Gbps",
  "flexMini2_5G.ports": "(5) GbE RJ45",
  "flexMini2_5G.powerMethod": "AC power or PoE input",
  "flexMini2_5G.uplinkSpeed": "2.5 Gbps",
  "formFactor.title": "Form Factor",
  "forwardingRate.title": "Forwarding Rate",
  "frequency.title": "Frequency",
  "g2Reader.description": "Compact, second-generation NFC card reader",
  "g2Reader.outdoorReady": "IP55 rain resistance\n(-30° to 45° C)",
  "g2ReaderPro.description": "Second-generation NFC card reader and intercom",
  "g2ReaderPro.note.1": "*The display will turn off when the ambient temperature is above/below the display operation temperature, but other functions will remain functional.",
  "g2ReaderPro.outdoorReady": "IP55 rain resistance\nDevice: -30 to 45° C (-22 to 113° F)\nDisplay:* -10 to 45° C (14 to 113° F)",
  "g2StarterKit.description": "Entry control for a single door with one reader",
  "g2StarterKit.includedAccessories": "(10) Access Cards",
  "g2StarterKit.includedHub": "(1) Door Hub",
  "g2StarterKit.includedReaders": "(1) G2 Reader",
  "g2StarterKitPro.description": "Complete entry and exit control for a single door with two readers",
  "g2StarterKitPro.includedAccessories": "(2) Pocket Keyfobs",
  "g2StarterKitPro.includedHub": "(1) Door Hub",
  "g2StarterKitPro.includedReaders": "(1) G2 Reader Pro\n(1) G2 Reader",
  "g3Intercom.description": "Indoor/outdoor intercom terminal with Touch Pass support.",
  "g3Reader.description": "Compact, third-generation NFC reader and request-to-exit device",
  "g3Reader.outdoorReady": "IP55 rain resistance (-30° to 45° C)",
  "g3ReaderFlex.description": "Third-generation NFC reader with a keypad",
  "g3ReaderFlex.outdoorReady": "IP55 rain resistance (-30° to 45° C)",
  "g3ReaderPro.description": "Third-generation NFC reader and video intercom",
  "g3ReaderPro.note.1": "*The display will turn off when the ambient temperature is above/below the display operation temperature, but other functions will remain functional.",
  "g3ReaderPro.outdoorReady": "IP55 rain resistance\nDevice: -30 to 45° C (-22 to 113° F)\nDisplay:* -10 to 45° C (14 to 113° F)",
  "g3StarterKit.description": "Entry control for a single door with one reader",
  "g3StarterKit.includedAccessories": "(2) Pocket Keyfobs",
  "g3StarterKit.includedHub": "(1) Door Hub Mini",
  "g3StarterKit.includedReaders": "(1) G3 Reader",
  "g3StarterKitPro.description": "Complete entry and exit control for a single door with two readers",
  "g3StarterKitPro.includedAccessories": "(2) Pocket Keyfobs",
  "g3StarterKitPro.includedHub": "(1) Door Hub",
  "g3StarterKitPro.includedReaders": "(1) G3 Reader Pro\n(1) G3 Reader",
  "g3TouchEnterprise.description": "Next-gen smartphone for UniFi Talk with 7\" display and app integration",
  "g3TouchEnterprise.description.1": "Next-gen Talk smartphone with 7\" display and app integration",
  "g3TouchPro.description": "Desktop smartphone for UniFi Talk with 5\" display and app integration",
  "g3TouchPro.description.1": "Desktop Talk smartphone with 5\" display and app integration",
  "g3TouchWall.description": "Next-gen wall-mountable smartphone for UniFi Talk with 7\" display and app integration",
  "g3TouchWall.description.1": "Next-gen wall-mountable Talk smartphone with 7\" display and app integration",
  "g4Instant.deployment": "WiFi and AC power adapter",
  "g4Instant.description": "WiFi-connected with\ntwo-way audio",
  "g4Instant.fieldOfView": "102.4° horizontal",
  "g4PTZ.description": "Ultra-responsive pan-tilt-zoom controls, and automatic tracking",
  "g4PTZ.fieldOfView": "64° to 3° horizontal,\nbased on zoom",
  "g4PTZ.opticalZoom": "22x optical zoom",
  "g5Bullet.description": "Outstanding performance and value",
  "g5Bullet.dimensions": "Without mount:\nØ75.5 x 74.4 mm (Ø3 x 2.9\")\nWith mount:\nØ75.5 x 150 mm (Ø3 x 5.9\")",
  "g5Bullet.fieldOfView": "84.4° horizontal",
  "g5Dome.description.1": "Low-profile with wide area coverage",
  "g5Dome.fieldOfView": "102.4° horizontal",
  "g5Dome.outdoorReady": "IPX4 (While covered)",
  "g5DomeUltra.description.1": "Redefining dome\ncamera compactness",
  "g5DomeUltra.fieldOfView.1": "102.4° horizontal",
  "g5Flex.description": "Compact with versatile mounting options",
  "g5Flex.fieldOfView": "102.4° horizontal",
  "g5Flex.outdoorReady": "IPX4 (While covered)",
  "g5PTZ.customDescription": "Compact, all-weather camera with versatile mounting options",
  "g5PTZ.description": "Compact, all-weather camera with ultra-low latency pan-tilt-zoom control and versatile mounting options",
  "g5PTZ.fieldOfView": "99.7° to 45.5° horizontal,\nbased on zoom",
  "g5PTZ.nightVision": "20 m (65 ft)",
  "g5PTZ.opticalZoom": "2x optical zoom",
  "g5Pro.description": "Incredible resolution, even at range",
  "g5Pro.fieldOfView": "109.9° to 35° horizontal,\nbased on zoom",
  "g5Pro.nightVision": "25 m (82 ft)\nup to 40 m (131 ft)*\n*With Vision Enhancer",
  "g5Ptz.dimensions": "Without mount:\nØ90 x 152.5 mm (Ø3.5 x 6\")\nWith mount:\n90 x 94 x 179.5 mm (3.5 x 3.7 x 7\")",
  "g5TurretUltra.description": "Weatherproof with\nlong-range night vision",
  "g5TurretUltra.fieldOfView": "102.4° horizontal",
  "g6180.description": "Indoor/outdoor dual sensor with panoramic 180° coverage",
  "g6180.fieldOfView": "(2) 180° horizontal",
  "g6180.nightVision": "20 m (65 ft)",
  "g6Bullet.description": "Multi-TOPS AI Engine, long-range IR night",
  "g6Bullet.dimensions": "Without mount:\nØ82 x 88.8 mm (Ø3.2 x 3.5\")\nWith mount:\nØ82 x 153 mm (Ø3.2 x 6\")",
  "g6Bullet.fieldOfView": "109.9° horizontal",
  "g6Cameras.availableQ3": "Available Q3",
  "g6Dome.description": "All-weather, vandal-proof 4K with a 1/1.8\" 8MP image sensor",
  "g6Dome.fieldOfView": "109.9° horizontal",
  "g6Dome.nightVision": "30 m (98 ft)",
  "g6Instant.deployment": "WiFi and AC power adapter",
  "g6Instant.description": "4K WiFi-connected with Multi-TOPS AI",
  "g6Instant.fieldOfView": "109.9° horizontal",
  "g6Instant.outdoorReady": "IPX5 (While covered)",
  "g6Pro360.description": "All-weather, vandal-resistant with panoramic 360° coverage",
  "g6Pro360.fieldOfView": "180° horizontal",
  "g6Pro360.nightVision": "15m (50 ft)\nSmart IR (4x controllable zones)",
  "g6Pro360.title": "G6 Pro 360",
  "g6ProBullet.description": "Multi-TOPS AI Engine, 1/1.2\" CMOS, long-range IR night",
  "g6ProBullet.fieldOfView": "Wide: H: 113.8°, V: 61.9°, D: 134°\nTele: H: 45.5°, V: 25.8°, D: 52°",
  "g6ProBullet.nightVision": "40 m (131 ft)\nUp to 60 m (197 ft) with Vision Enhancer",
  "g6Ptz.comingSoonButtonText": "Available June 17th",
  "g6Ptz.description": "All-weather, 4K dual-lens camera with 10x hybrid zoom",
  "g6Ptz.dimensions": "Without mount:\nØ107.2 x 104.5 x 203.2 mm (Ø4.2 x 4.1 x 8\")\nWith mount:\nØ107.2 x 111 x 230.2 mm (Ø4.2 x 4.8 x 9.1\")",
  "g6Ptz.fieldOfView": "109.9° to 26.6° horizontal,\nbased on zoom",
  "g6Ptz.imageSensor": "Wide: 1/1.8\" 8MP\nTele: 1/1.8\" 8MP",
  "g6Ptz.opticalZoom": "10x hybrid zoom\n*5x optical and 2x digital",
  "g6Turret.description": "All-weather 4K PoE camera with Multi-TOPS AI",
  "g6Turret.fieldOfView": "109.9° horizontal",
  "gateAccessStarterKit.description": "Vehicle gate access control using the connected Intercom",
  "gateAccessStarterKit.footnote.comingSoon": "Available July 19 in the US and Canada.",
  "gateAccessStarterKit.includedAccessories": "(1) PoE over 2-Wire Retrofit Extenders\n(1) PoE++ Adapter",
  "gateAccessStarterKit.includedHub": "(1) Gate Hub",
  "gateAccessStarterKit.includedReaders": "(1) Intercom",
  "gateHub.description": "Authorize gate access with License Plate Unlock",
  "gateHub.inputTerminals": "(1) Gate exit request\n\n(1) Gate position\n(1) Side door exit request\n(1) Side door position\n(1) Emergency",
  "gateHub.outputRelays": "(2) Gate lock terminals (dry)\n(1) Side lock terminal (12V)\n(1) AUX",
  "gateHub.poePorts": "(4) PoE for access readers and cameras",
  "gatewayEnterprise.description": "Multi-WAN gateway with 25 Gbps performance for enterprise‑scale networks",
  "gatewayEnterprise.note.managedWithUniFiHosting": "*When managed with a CloudKey Enterprise or Official UniFi Hosting.",
  "gatewayEnterprise.note.remappableToWan": "All networking interfaces are LAN/WAN remappable.",
  "gatewayEnterprise.powerRedundancy": "Dual hot-swappable PSUs",
  "gatewayFiber.description": "Desktop 10G independent gateway with integrated 4-port 2.5 GbE switch.",
  "gatewayFiber.formFactor": "Desktop",
  "gatewayLite.description": "Compact and powerful gateway ideal for smaller networks",
  "gatewayMax.description": "Compact, multi-WAN gateway for high-speed networking at small-to-medium sites",
  "gatewayMax.lanPorts": "(4) 2.5 GbE RJ45 including (1) remappable to WAN",
  "gatewayProfessional.description": "Multi-WAN gateway designed to protect medium to large-sized networks",
  "gatewayProfessional.powerRedundancy": "With UniFi Power Backup",
  "generalRedundancy.title": "Redundancy",
  "gponOlt.bridge": "Bridge only",
  "gponOlt.description": "Use with the UF-GP-\nB+ & UF-GP-C+ SFP",
  "gpsLocationTracking.title": "GPS Location Tracking",
  "greetingMessages.title": "Greeting messages",
  "hand.title": "Handwave Request to Exit",
  "hdmiCec.title": "HDMI CEC",
  "hdmiCec.tooltip": "Use the CEC (Consumer Electronics Control) feature of compatible HDMI displays to automatically power on/off along with the Display Cast. <a href=\"https://help.ui.com/hc/en-us/articles/12825727969815-UniFi-Connect-Automatically-Control-Display-with-Cast\">Learn more.</a>",
  "healthMonitoring.title": "Health and Uptime Monitoring",
  "hiCapacityAggregation.description": "High-capacity 10G SFP+ and 25G SFP28 connections",
  "highPerformanceSpeaker.title.1": "High-Performance Speaker",
  "hubDoor.title": "Door position sensor inputs",
  "identityAppUnlock.title": "Unlock using Identity App",
  "idsIpsThroughput.title": "IDS/IPS Throughput",
  "imageSensor.title": "Image Sensor",
  "includedAccessories.title": "Included Accessories",
  "includedHub.title": "Included Hub",
  "includedReaders.title": "Included Readers",
  "includedUnifiApps.title": "Included UniFi Applications",
  "includedUnifiApps.tooltip": "Purpose-built software used to manage specific technologies like networking, security cameras, access control, VoIP, and more.",
  "industrial.description": "High-power PoE++ output with a ruggedized enclosure",
  "inputTerminals.title": "Input Terminals",
  "installation.title": "Installation",
  "integratedBluetooth.title": "Integrated Bluetooth",
  "integratedGps.title": "Integrated GPS",
  "integratedPoeSwitch.title": "Integrated PoE/PoE+ Switch",
  "integratedRadome.title": "Integrated Radome",
  "integratedSwitch.title": "Integrated Switch",
  "integratedWiFi.title": "Integrated WiFi",
  "integratedWiFi6.title": "Integrated WiFi 6",
  "intercom.description": "Indoor/outdoor intercom terminal for managing residential and commercial building entry requests",
  "intercom.description.1": "Indoor/outdoor intercom terminal",
  "intercom.note.1": "*The display will turn off when the ambient temperature is above/below the display operation temperature, but other functions will remain functional.",
  "intercom.outdoorReady": "IP65 rain resistance\nDevice: -30 to 60° C (-22 to 140° F)\nDisplay:* -25 to 60° C (-13 to 140° F)",
  "intercoms.common.outdoorReady": "IP65 rain resistance (-30 to 60° C)",
  "interiorDesign.title": "Interior Design",
  "internalBatterySupport.title": "Internal Battery Support",
  "internalSwitch.title": "Internal Switch",
  "lanPorts.title": "LAN Ports",
  "layerTwoFunctionality.title": "Layer 2 Functionality",
  "ledDisplay.title": "LED Display",
  "licenseFreeNextAiSSLInspection.title": "License-Free NeXT AI SSL Inspection",
  "licensePlateRecognition.title": "License Plate\nRecognition",
  "linkPuncturing.title": "Link Puncturing",
  "linkRange.title": "Link Range",
  "lite16PoE.description": "GbE ports with up to PoE+ output",
  "lite8PoE.description": "GbE ports with up to PoE+ output",
  "liteApGps.dimensions": "361 x 124.6 x 71.3 mm",
  "liteApGps.pps": "40K",
  "liteApGps.spectralEfficiency": "8.12 bps/Hz",
  "liteApGps.weight": "752 g",
  "liteApGps.windLoading": "77 N at 200 km/h",
  "liteBeam5AC.description": "Long-Range Client",
  "liteBeam5AC.dimensions": "358 x 271.95 x 272.5 mm",
  "liteBeam5AC.weight": "Without mount: 800 g\nWith mount 980 g",
  "liteBeam5AC.windLoading": "275 N at 200 km/h",
  "liteBeam5ACExtremeRange.description": "Long-Range Client",
  "liteBeam5ACExtremeRange.dimensions": "747 x 525 x 347 mm",
  "liteBeam5ACExtremeRange.linkRange": "30+ km",
  "liteBeam5ACExtremeRange.windLoading": "1100 N at 200 km/h",
  "liteBeam5ACLongRange.description": "Long-Range Client",
  "liteBeam5ACLongRange.dimensions": "512 x 385.8 x 258.3 mm",
  "liteBeam5ACLongRange.linkRange": "25+ km",
  "liteBeam5ACLongRange.weight": "Without mount: 1.4 kg\nWith mount: 1.7 kg",
  "liteBeam5ACLongRange.windLoading": "550 N at 200 km/h",
  "liteBeamM5.description": "Long-Range Client",
  "liteBeamM5.dimensions": "362 x 267 x 184 mm",
  "liteBeamM5.networkInterface": "(1) 10/100 MbE RJ45 port",
  "liteBeamM5.throughput": "Up to 100 Mbps",
  "liteBeamM5.weight": "750 g",
  "lteBackup.availability": "United States*",
  "lteBackup.dataPlan": "$15/mo for 1 GB\n$10 for each additional GB",
  "lteBackup.description": "Designed for plug-and-play deployment",
  "lteBackup.notes": "*Works with the AT&T network.",
  "lteBackup.simCard": "Integrated AT&T SIM",
  "lteBackupProfessional.availability": "United States*\nEurope\nUnited Kingdom",
  "lteBackupProfessional.description": "Flexibility to bring your own SIM and data plan",
  "lteBackupProfessional.notes": "*Works with the AT&T network.",
  "lteBackupProfessional.simCard": "Bring your own nano-SIM for LTE data",
  "ltuExtremeRange.description": "High-capacity, long-distance PtP (bridge) and PtMP links",
  "ltuExtremeRange.dimensions": "747 x 525 x 347 mm",
  "ltuExtremeRange.maxLinkRange": "30+ km",
  "ltuExtremeRange.maxThroughput": "900+ Mbps",
  "ltuExtremeRange.networkInterface": "GbE RJ45 port",
  "ltuExtremeRange.windLoading": "1100 N at 200 km/h",
  "ltuInstant.description": "Functions in a point-to-multipoint",
  "ltuInstant.dimensions": "Feed: 201.5 x 64.2 x 56.2 mm\nAntenna: 358 x 271.9 x 288.5",
  "ltuInstant.maxThroughput": "900+ Mbps",
  "ltuInstant.networkInterface": "GbE RJ45 port",
  "ltuInstant.notes": "Plug-and-play conversion module for existing LBE-5AC-Gen2 deployments.",
  "ltuInstant.weight": "Feed: 215 g\nAntenna: 890 g",
  "ltuInstant.windLoading": "275 N at 200 km/h",
  "ltuLite.description": "Lightweight, compact 60 GHz PtMP station",
  "ltuLite.dimensions": "153 x 84 x 39.5 mm",
  "ltuLite.maxLinkRange": "10+ km",
  "ltuLite.maxThroughput": "900+ Mbps",
  "ltuLite.weight": "250 g",
  "ltuLite.windLoading": "20 N at 200 km/h",
  "ltuLongRange.description": "60 GHz PtMP station powered by Wave Technology",
  "ltuLongRange.dimensions": "512.5 x 385.75 x 258.3 mm",
  "ltuLongRange.maxLinkRange": "30+ km",
  "ltuLongRange.maxThroughput": "900+ Mbps",
  "ltuLongRange.networkInterface": "GbE RJ45 port",
  "ltuLongRange.weight": "Without mount: 1.4 kg\nWith mount: 1.7 kg",
  "ltuLongRange.windLoading": "550 N at 200 km/h",
  "ltuPro.description": "Compact 60 GHz PtMP station",
  "ltuPro.dimensions": "316.5 x 316.5 x 174.3 mm",
  "ltuPro.maxLinkRange": "25+ km",
  "ltuPro.maxThroughput": "900+ Mbps",
  "ltuPro.networkInterface": "GbE RJ45 port",
  "ltuPro.windLoading": "150 N at 200 km/h",
  "managedCameras.title": "Managed Cameras",
  "managedCameras.tooltip": "Recommended limits are for a single NVR based on a specific camera video resolution.\n<a href=\"https://help.ui.com/hc/en-us/articles/360063280653-UniFi-Protect-Supported-Camera-Limits\">Learn more.</a>",
  "managedUnifiDevices.title": "Managed UniFi Devices",
  "maxChargingOutput.title": "Max Charging Output",
  "maxLinkRange.title": "Max. Link Range",
  "maxThroughput.title": "Max. Throughput",
  "maxTotalThroughput.title": "Max. Total Throughput",
  "maxWanPortCount.title": "Max. WAN Port Count",
  "maximumRange.title": "Maximum Range",
  "mcLagSupport.title": "MC-LAG Support",
  "mgmtPort.title": "MGMT Port",
  "missionCritical.description": "Integrated battery for uninterruptible PoE",
  "missionCritical.powerRedundancy": "Integrated battery for uninterruptible operation",
  "mobileAppAccess.title": "UniFi Identity Mobile Access",
  "mobileTap.title": "Mobile Tap Access",
  "modelCompare.reviewIn.tooltip": "Review in",
  "mountType.title": "Mount Type",
  "mounting.title": "Mounting",
  "nanoBeam2AC.description": "Compact Client",
  "nanoBeam2AC.dimensions": "189 x 189 x 125 mm",
  "nanoBeam2AC.maxThroughput": "150+ Mbps",
  "nanoBeam2AC.weight": "530 g",
  "nanoBeam2AC.windLoading": "45.4 N at 200 km/h",
  "nanoBeam5AC.description": "Compact Client",
  "nanoBeam5AC.dimensions": "189 x 189 x 125 mm",
  "nanoBeam5AC.linkRange": "10+ km",
  "nanoBeam5AC.networkInterface": "(2) GbE RJ45 port",
  "nanoBeam5AC.weight": "530 g",
  "nanoBeam5AC.windLoading": "45.4 N at 200 km/h",
  "nanoStation5AC.description": "Compact Client",
  "nanoStation5AC.dimensions": "257 x 84 x 41 mm",
  "nanoStation5AC.networkInterface": "(2) GbE RJ45 ports\nSecondary LAN with PoE out support",
  "nanoStation5AC.powerMethod": "PoE alternative A\nPassive PoE 2-pair",
  "nanoStation5AC.weight": "233 g",
  "nanoStation5ACLoco.description": "Compact Client",
  "nanoStation5ACLoco.dimensions": "179 x 77.5 x 59.1 mm",
  "nanoStation5ACLoco.linkRange": "10+ km",
  "nanoStation5ACLoco.weight": "180 g",
  "natThroughput.title": "NAT Throughput",
  "networkInterface.title": "Network Interface",
  "networkingInterface.title": "Networking Interface",
  "nextAiInspection.title": "License-Free NeXT AI Inspection",
  "nextAiInspection.tooltip": "Inspect encrypted traffic to analyze its contents for security monitoring and content filtering purposes. <a href=\"https://help.ui.com/hc/en-us/articles/18068491373975\">Learn more</a>",
  "nfcCard.title": "NFC Card & Keyfob Access",
  "nightVision.title": "IR Night Vision",
  "nvr.description": "Excellent performance for businesses of any size",
  "nvr.formFactor": "1U rack-mountable",
  "nvr.storageCapacity": "(4) 3.5\" drive bays",
  "nvrHdd35Bay.title": "3.5\" NVR HDD Bay",
  "nvrInstant.description": "Plug-and-play enterprise physical security",
  "nvrInstant.formFactor": "Compact Desktop\n Wall, Din rail mount (Included)",
  "nvrInstant.networkingInterface": "(1) GbE RJ45\n(6) GbE PoE RJ45\n(1) HDMI port (Viewport)",
  "nvrInstant.storageCapacity": "(1) 3.5\" drive bay",
  "nvrPowerBackup.title": "Power Redundancy",
  "nvrPro.description": "Enterprise-grade performance and scalability",
  "nvrPro.formFactor": "2U rack-mountable",
  "nvrPro.storageCapacity": "(7) 3.5\" drive bays",
  "nvrStacking.title": "NVR Stacking",
  "nvrStacking.tooltip": "Increase the camera capacity and storage retention of a deployment while managing settings, user access, notifications, and more from a single interface.\n<a href=\"https://help.ui.com/hc/en-us/articles/14881658961303-UNVR-Stacking\">Learn more.</a>",
  "officialUniFiHosting.deployment": "Subscription service",
  "officialUniFiHosting.description": "Scalable multi-site management without an on-premises UniFi Console",
  "officialUniFiHosting.unifiDevices": "Up to 1,000 based on plan",
  "opticalZoom.title": "Optical Zoom",
  "outdoorReady.title.1": "Outdoor-Ready",
  "outputRelays.title": "Output Relays",
  "paymentTerminalSupport.title": "Payment Terminal Support",
  "paymentTerminalSupport.tooltip": "Offer EV charging as a service with the UniFi EV Station Pro. Available in the United States. <a href='https://help.ui.com/hc/en-us/articles/20643869756951-UniFi-Connect-Collect-Payment-for-EV-Charging'>Learn more.</a>",
  "pbxSupport.title": "3rd Party PBX Support",
  "phoneTouch.description": "Entry-level desktop smartphone designed to elevate productivity",
  "phoneTouch.speakerphone": "Standard",
  "phoneTouchMax.description": "Premium desktop smartphone that delivers breakthrough user experiences",
  "pinAccess.title": "PIN Access",
  "poeAvailability.title": "PoE Availability",
  "poeInput.title": "PoE Input",
  "poeOutput.title": "PoE Output",
  "poePlus.title": "PoE out ports for Access Readers",
  "poePlus2.title": "PoE out ports for Cameras",
  "poePorts.title": "PoE Ports",
  "poeSwitch.title": "PoE Switch",
  "portCount.title": "Port Count",
  "portLayout.title": "Port Layout",
  "ports.title": "Ports",
  "powerBeam2AC400.dimensions": "420 x 420 x 289 mm",
  "powerBeam2AC400.maxLinkRange": "25+ km",
  "powerBeam2AC400.windLoading": "342.5 N at 200 km/h",
  "powerBeam5AC.dimensions": "420 x 420 x 230 mm",
  "powerBeam5AC.windLoading": "380 N at 200 km/h",
  "powerBeam5AC620.dimensions": "620 x 620 x 386 mm",
  "powerBeam5AC620.linkRange": "25+ km",
  "powerBeam5AC620.windLoading": "Without radome: 1510 N at 200 km/h\nWith radome: 1830 N at 200 km/h",
  "powerBeam5ACISO.dimensions": "420 x 420 x 230 mm",
  "powerBeam5ACISO.windLoading": "380 N at 200 km/h",
  "powerLoadBalancing.title": "Power Load Balancing",
  "powerMethod.title": "Power Method",
  "powerMethodPoe.title": "Power Method",
  "powerRedundancy.title": "Power Redundancy",
  "powerTransportOutput.title": "Power TransPort Output",
  "pps.title": "PPS",
  "precisionAlignmentMount.title": "Precision Alignment Mount",
  "prismFilters.title": "PRISM Active RF Filtering",
  "prismStation5AC.dimensions": "Device: 155 x 155 x 104 mm\nMounting hardware: 83 x 117 x 69 mm",
  "prismStation5AC.maxThroughput": "500+ Mbps",
  "prismStation5AC.pps": "50K",
  "prismStation5AC.spectralEfficiency": "8.12 bps/Hz",
  "prismStation5AC.weight": "Device: 800 g\nMounting hardware: 800 g",
  "prismStation5AC.windLoading": "31 N at 200 km/h",
  "proAvSupport.title": "Pro A/V Support",
  "proAvSupport.tooltip": "Accelerate Pro A/V deployment with pre-configured port profiles that use QoS to automatically prioritize latency-sensitive audio and video traffic. <a href=\"https://help.ui.com/hc/en-us/articles/18125733726615\">Learn more</a>",
  "proLongDistance.cameraResolution": "Detailed imaging, even in extreme low light",
  "proLongDistance.description": "Detailed imaging, even in extreme low light",
  "proLongDistance.fieldOfView": "53° horizontal",
  "proSwitches.placeholder": "Layer 3 switch capable of high-power PoE++ output.",
  "proXg8PoE.comingSoonButtonText": "Available May 2025",
  "proXg8PoE.description": "Compact, Professional-grade 8-port Etherlighting™ switch",
  "proXgAggregation.comingSoonButtonText": "Available August 2025",
  "proXgAggregation.description": "Etherlighting™ switch with high-capacity 25G SFP28 connections",
  "productGroup.enterprise.title": "2.5/10 GbE 1U",
  "productGroup.gigabitEthernet.title": "GbE 1U Standard",
  "productGroup.professional.title": "Professional",
  "productGroup.professionalMax.title": "Professional Max",
  "productGroup.twoPointFiveTenGigabitEthernet.title": "2.5/10 GbE 1U",
  "productListGroup.CompactAndInteriorDesign.title": "Compact Cameras",
  "productListGroup.compact.title": "Compact",
  "productListGroup.controlHubs.title": "Control Hubs",
  "productListGroup.domeTurret.title": "Dome & Turret",
  "productListGroup.enterprise.customTitle": "2.5/10 GbE 1U",
  "productListGroup.enterprise.title": "Enterprise",
  "productListGroup.gatewaysCompact.title": "Compact",
  "productListGroup.interiorDesign.title": "Interior Design",
  "productListGroup.largeScale.title": "Large Scale",
  "productListGroup.professional.title": "Professional",
  "productListGroup.professionalMax.title": "Professional Max",
  "productListGroup.ptz.title": "PTZ",
  "productListGroup.readersAndIntercom.title": "Readers & Intercom",
  "productListGroup.starterKits.title": "Starter Kits",
  "productListGroup.switchingCompact.title": "Compact",
  "productListGroup.switchingEnterprise.title": "Enterprise",
  "productListGroup.switchingProfessional.title": "Professional",
  "productListGroup.switchingValue.title": "Value",
  "productListGroup.wifiBuildingBridge.title": "Building Bridging",
  "productListGroup.wifiDeviceBridge.title": "Device Bridging",
  "productListGroup.wifiE7.title": "E7",
  "productListGroup.wifiEnterprise7.title": "Enterprise",
  "productListGroup.wifiFlagship.title": "Flagship",
  "productListGroup.wifiIntegrated.title": "WiFi Integrated",
  "productListGroup.wifiMegaCapacity.title": "Mega Capacity",
  "productListGroup.wifiOutdoor.title": "Outdoor",
  "productListGroup.wifiWall.title": "Wall",
  "professional24.description": "Layer 3 switch with 10G SFP+ and fanless cooling.",
  "professional24PoE.description": "Layer 3 switch capable of high-power PoE++ output.",
  "professional48.description": "Layer 3 switch with 10G SFP+ and fanless cooling.",
  "professional48PoE.description": "Layer 3 switch capable of high-power PoE++ output.",
  "professional8PoE.description": "GbE ports with PoE+ and PoE++ output",
  "professionalHd24.description": "L3 switch with 10/2.5GbE and 10G SFP+ ports",
  "professionalHd24Poe.description": "L3 switch with 10/2.5GbE PoE++ and 10G SFP+",
  "professionalMax16.description": "16-port, Layer 3 Etherlighting™ switch with 2.5 GbE",
  "professionalMax16.mounting": "Desktop\nWall\nRack*",
  "professionalMax16.notes": "*With optional Rack Mount accessory.",
  "professionalMax16PoE.description": "Layer 3 Etherlighting™ switch with 2.5 GbE and PoE++ output",
  "professionalMax16PoE.mounting": "Desktop\nWall\nRack*",
  "professionalMax16PoE.notes": "*With optional Rack Mount accessory.",
  "professionalMax16PoE.poeAvailability": "180 W",
  "professionalMax24.description": "24-port, Layer 3 Etherlighting™ switch with 2.5 GbE",
  "professionalMax24PoE.description": "Layer 3 Etherlighting™ switch with 2.5 GbE and PoE++ output",
  "professionalMax48.description": "48-port, Layer 3 Etherlighting™ switch with 2.5 GbE",
  "professionalMax48PoE.description": "Layer 3 Etherlighting™ switch with 2.5 GbE and PoE++ output",
  "professionalXg10PoE.description": "1U L3 PoE+++ switch with 10×10GbE and 2×10G SFP+",
  "professionalXg24PoE.description": "24-port L3 switch with 2.5GbE and PoE++",
  "professionalXg48PoE.description": "48-port L3 switch with 2.5GbE and PoE++",
  "ptz.title": "PTZ",
  "radio6Ghz.title": "6 GHz Radio",
  "radios.title": "Radios",
  "radiusCoverage.title": "Coverage",
  "readerLite.customBadge": "Best Value",
  "readerLite.description": "Supporting NFC reader and handwave door unlocking",
  "readerLite.outdoorReady": "IP54 rain resistance\n(-20° to 40° C)",
  "readerPowerMethod.poeViaUniFiControlHub": "PoE via UniFi Control Hub",
  "readerPowerMethod.title": "Power Method",
  "redundancy.title": "DC redundancy",
  "redundantRj45Port.title": "Redundant RJ45 Port for High Availability",
  "rejectRF.title": "Isolation Antenna Design Rejects RF noise",
  "rfFilteringTechnology.title": "High Selectivity PRISM™ RF Filtering Technology",
  "rocketAcLite.dimensions": "162 x 84 x 37 mm",
  "rocketAcLite.maxThroughput": "500+ Mbps",
  "rocketAcLite.pps": "50K",
  "rocketAcLite.spectralEfficiency": "8.12 bps/Hz",
  "rocketAcLite.weight": "250 g",
  "rocketPrism5AC.dimensions": "88 x 40 x 230 mm",
  "rocketPrism5AC.maxThroughput": "500+ Mbps",
  "rocketPrism5AC.pps": "50K",
  "rocketPrism5AC.spectralEfficiency": "8.12 bps/Hz",
  "rocketPrism5AC.weight": "400 g",
  "rocketPrism5AC.windLoading": "342.5 N at 200 km/h",
  "screen.title": "Screen",
  "simCard.title": "SIM Card",
  "simultaneousUsersConnected.title": "Simultaneous Users Connected",
  "smartDetections.title": "Smart Detections",
  "smartDetections.tooltip": "Includes person, vehicle, and motion detection, as well as smoke/CO alarm detection on cameras with a microphone.",
  "smsLte.title": "SMS by LTE CAT-M1",
  "sound.title": "Audio",
  "speakerphone.title": "Speakerphone",
  "spectralEfficiency.title": "Spectral Efficiency",
  "standard16PoEGen1.description": "Layer 2 PoE switch from first generation",
  "standard16poe.description": "16-port (8 PoE+) L2 PoE switch with fanless cooling",
  "standard24.description": "24-port L2 PoE switch with fanless cooling",
  "standard24PoE.description": "24-port (16 PoE+) L2 PoE switch with fanless cooling",
  "standard24PoEGen1.description": "Layer 2 PoE switch from first generation",
  "standard48.description": "48-port L2 PoE switch with fanless cooling",
  "standard48PoEGen1.description": "Layer 2 PoE switch from first generation",
  "standard48poe.description": "48-port (32 PoE+) L2 PoE switch with fanless cooling",
  "standardSwitches.desc.placeholder": "Layer 2 switch with a silent, fanless cooling system",
  "stationSecurityModes.title": "Station Security Modes",
  "stationSecurityModes.tooltip": "Optionally require users to unlock the EV Station before charging. <a href='https://help.ui.com/hc/en-us/articles/21170042012439-UniFi-Connect-Manage-EV-Stations'>Learn more.</a>",
  "storage.title": "Storage",
  "storageCapacity.title": "Storage Capacity",
  "subscriptionLockedAndUnlockedModels.title": "Subscription Locked and Unlocked Models",
  "subscriptionLockedAndUnlockedModels.tooltip": "<p><strong>Subscription Locked</strong> phones must be assigned to a user with a unique, personal UniFi Talk number and have an Internet connection to function.</p><p><strong>Subscription Unlocked</strong> are recommended phones for configurations where users only share numbers with a group and are not assigned a unique, personal UniFi Talk number.</p>",
  "swissArmy.antennaType.omnidirectional": "Omnidirectional*",
  "swissArmyKnifeUltra.description": "Ultra-compact with external antenna support and incredible value",
  "swissArmyKnifeUltra.mounting": "Wall\nCeiling\nPole\nDesktop",
  "swissArmyKnifeUltra.mounting.1": "Wall\nCeiling\nPole\nDesktop**",
  "swissArmyKnifeUltra.notes.externalAntenna": "*External directional and omni antennas sold separately.",
  "swissArmyKnifeUltra.notes.mounting": "**Table Stand sold separately.",
  "swissArmyKnifeUltra.wifiTechnology": "WiFi 5\nDual-radio 2.4 / 5 GHz\n4 spatial streams",
  "switchTechnology.title": "Switch Technology",
  "switchUltra.description.v2": "PoE+ output with versatile mounting",
  "switchUltra.mounting": "Magnetic Base\nDesktop\nWall",
  "switchUltra.note": "*AC power or PoE+/PoE++ input required for PoE output.",
  "switchUltra.poeAvailability": "Up to 202 W",
  "switchUltra.powerMethod": "AC power or PoE to PoE++ input*",
  "switchesEnterprise.description": "High-capacity",
  "switchesEnterprise.downlinkSpeed": "Up to 25 Gbps",
  "switchesEnterprise.notes.1": "*Available on select models.",
  "switchesEnterprise.poeAvailability": "Up to 2150 W",
  "switchesEnterprise.poeOutput": "Up to PoE+++",
  "switchesEnterprise.portCount": "24 or 48",
  "switchesEnterprise.powerRedundancy": "UniFi Power Backup ready\nDual hot-swappable PSUs",
  "switchesEnterprise.switchTechnology": "Up to Layer 3",
  "switchesEnterprise.uplinkSpeed": "Up to 100 Gbps",
  "switchesProfessional.description": "High-power",
  "switchesProfessional.poeAvailability": "Up to 600 W",
  "switchesProfessional.portCount": "24 or 48",
  "switchesProfessionalHd.description": "10 GbE and Etherlighting™",
  "switchesProfessionalMax.description": "2.5 GbE and Etherlighting™",
  "switchesProfessionalMax.poeAvailability": "Up to 720 W",
  "switchesProfessionalMax.portCount": "16, 24, or 48",
  "switchesProfessionalXg.description": "Professional-grade",
  "switchesProfessionalXg.poeAvailability": "Up to 1080 W",
  "switchesProfessionalXg.portCount": "10, 24 or 48",
  "switchesProfessionalXg.uplinkSpeed": "Up to 25 Gbps",
  "switchesStandard.customTitle": "GbE 1U",
  "switchesStandard.description": "Fanless and silent",
  "switchesStandard.poeAvailability": "Up to 195 W",
  "switchesStandard.portCount": "16, 24, or 48",
  "switchesUtility.customTitle": "Compact",
  "switchesUtility.description": "Compact versatility",
  "switchesUtility.mounting": "Desktop\nPole\nWall",
  "switchesUtility.outdoorReady": "Select models",
  "switchesUtility.poeAvailability": "Up to 430 W",
  "switchesUtility.portCount": "Up to 16",
  "switchesUtility.powerMethod": "AC power and/or PoE input,\nbased on model",
  "switchesUtility.switchTechnology": "Up to Layer 3",
  "switchesWan.description": "2 Cloud Gateways to ISP",
  "switchesWan.powerRedundancy": "(2) AC inputs",
  "switchingCapacity.title": "Switching Capacity",
  "swivelLatency.title": "< 1ms Latency",
  "swivelPackets.title": "Packets per Second",
  "swivelPowerMethod.title": "Power Method",
  "swivelSpectralEfficiency.title": "Spectral Efficiency",
  "tamperResistance.title": "Tamper Resistance",
  "technology.title": "Technology",
  "theta.aiRecognition": "With included Wide-Angle lens or add-on Long-Distance lens",
  "theta.cameraAudio": "Two-way audio with\noptional AI Theta Audio",
  "theta.description": "The first security camera for interior design",
  "theta.faceRecognition": "With Wide-Angle lens and Long Distance lens",
  "theta.fieldOfView": "97.5° horizontal or 360°\npanoramic, based on lens",
  "theta.licensePlateRecognition": "With Wide-Angle lens",
  "theta360.description": "Ideal for overhead panoramic coverage",
  "theta360.fieldOfView": "360° horizontal",
  "thetaAILongDistance.description": "Ideal for capturing important details",
  "thetaAILongDistance.fieldOfView": "36.2° horizontal",
  "thetaPro.aiRecognition": "With add-on Long-Distance or Wide-Angle lens",
  "thetaPro.cameraAudio": "Two-way audio with\noptional AI Theta Audio",
  "thetaPro.description": "360° panoramic coverage with incredible image quality",
  "thetaPro.faceRecognition": "With Wide-Angle lens and Long Distance lens",
  "thetaPro.fieldOfView": "360° panoramic",
  "thetaPro.licensePlateRecognition": "With add-on Long-Distance or Wide-Angle lens",
  "thetaPro360.cameraResolution": "4K with enhanced low-light performance and dynamic range",
  "thetaPro360.description": "Panoramic coverage, even in extreme low light",
  "thetaPro360.fieldOfView": "360° panoramic",
  "thetaProWideAngle.cameraResolution": "4K with enhanced low-light performance and dynamic range",
  "thetaProWideAngle.description": "Wide area coverage, even in extreme low light",
  "thetaProWideAngle.fieldOfView": "110.4° horizontal",
  "thetaWideAngle.description": "Ideal for wide area coverage of busy spaces",
  "thetaWideAngle.fieldOfView": "97.5° horizontal",
  "throughput.title": "Throughput",
  "totalNonBlockingThroughput.title": "Total Non-Blocking Throughput",
  "touchPassSupport.title": "Touch Pass Support",
  "touchscreen.title": "Touchscreen display",
  "touchscreen13inch.title": "1.3\" Touchscreen",
  "trafficShaping.title": "Traffic Shaping Functionality",
  "twoWayIntercom.title": "Two-Way Intercom & Doorbell Access",
  "u6Enterprise.description": "Incredible WiFi 6E",
  "u6Enterprise.dimensions": "Ø220 x 48 mm\n(Ø8.7 x 1.9\")",
  "u6Enterprise.wifiTechnology": "WiFi 6E\nTri-radio 2.4 / 5 / 6 GHz\n10 spatial streams",
  "u6EnterpriseInWall.description": "Additional 6 GHz radio for high-density environments",
  "u6EnterpriseInWall.dimensions": "159.7 x 156.7 x 33.8 mm\n(6.3 x 6.2 x 1.3\")",
  "u6EnterpriseInWall.mounting": "In-Wall",
  "u6EnterpriseInWall.notes": "*PoE++ required for PoE out.",
  "u6EnterpriseInWall.wifiTechnology": "WiFi 6E\nTri-radio 2.4 / 5 / 6 GHz\n10 spatial streams",
  "u6Extender.customization": "With Cover accessory",
  "u6Extender.description": "Easy-to-deploy WiFi 6 extender that plugs into a wall outlet",
  "u6Extender.dimensions.eu": "169.7 x 112.2 x 77.6 mm\n(6.7 x 4.4 x 3.1\")",
  "u6Extender.dimensions.us": "169.7 x 112.2 x 32.2 mm\n(6.7 x 4.4 x 1.3\")",
  "u6Extender.mounting": "Outlet",
  "u6Extender.uplink": "Meshes with UniFi WiFi",
  "u6Extender.wifiPowerMethod": "Plugs in to AC wall outlet",
  "u6Extender.wifiTechnology": "WiFi 6\nDual-radio 2.4 / 5 GHz\n6 spatial streams",
  "u6InWall.description": "Low-profile WiFi 6 AP with a built-in PoE switch",
  "u6InWall.dimensions": "139.7 x 96 x 31.2 mm\n(5.5 x 3.8 x 1.3\")",
  "u6InWall.integratedSwitch": "(4) GbE with\n(1) PoE out",
  "u6InWall.mounting": "In-Wall",
  "u6InWall.notes": "*PoE+ required for PoE out.",
  "u6InWall.wifiTechnology": "WiFi 6\nDual-radio 2.4 / 5 GHz\n6 spatial streams",
  "u6LR.description": "Extended coverage",
  "u6LR.dimensions": "Ø220 x 48 mm\n(Ø8.7 x 1.9\")",
  "u6LR.wifiTechnology": "WiFi 6\nDual-radio 2.4 / 5 GHz\n8 spatial streams",
  "u6Lite.description": "Outstanding value",
  "u6Lite.wifiTechnology": "WiFi 6\nDual-radio 2.4 / 5 GHz\n4 spatial streams",
  "u6Mesh.description": "Sleek design for versatile indoor/outdoor installation",
  "u6Mesh.mounting": "Desktop\nWall\nPole\nCeiling",
  "u6Mesh.mounting.1": "Desktop\nWall\nPole\nCeiling*",
  "u6Mesh.wifiTechnology": "WiFi 6\nDual-radio 2.4 / 5 GHz\n6 spatial streams",
  "u6MeshPro.description": "Integrated omni super antenna for extended range",
  "u6MeshPro.wifiTechnology": "WiFi 6\nDual-radio 2.4 / 5 GHz\n4 spatial streams",
  "u6Plus.description": "Outstanding value",
  "u6Plus.dimensions": "Ø160 x 33 mm\n(Ø6.3 x 1.3\")",
  "u6Plus.wifiTechnology": "WiFi 6\nDual-radio 2.4 / 5 GHz\n4 spatial streams",
  "u6Pro.description": "Impressive performance",
  "u6Pro.dimensions": "Ø197 x 35 mm\n(Ø7.8 x 1.4\")",
  "u6Pro.wifiTechnology": "WiFi 6\nDual-radio 2.4 / 5 GHz\n6 spatial streams",
  "u6mesh.notes.mounting": "*In-Ceiling Mount sold separately.",
  "u7InWall.description": "WiFi 7 AP with integrated 2.5 GbE PoE switch",
  "u7InWall.dimensions": "137 x 98.7 x 30.2 mm\n(5.4 x 3.9 x 1.2\")",
  "u7InWall.integratedSwitch": "(1) 2.5GbE PoE output",
  "u7InWall.notes.1": "*PoE+ required for PoE out.",
  "u7InWall.wifiCoverage": "115 m² (1,250 ft²)",
  "u7InWall.wifiMounting": "In-Wall",
  "u7InWall.wifiTechnology": "WiFi 7\nDual-radio 2.4 / 5 GHz\n4 spatial streams",
  "u7LR.description.1": "WiFi 7 AP with 5 streams and extended signal range",
  "u7LR.dimensions": "Ø175.7 x 43 mm\n(Ø6.9 x 1.7\")",
  "u7LR.wifiTechnology": "WiFi 7\nDual-radio 2.4 / 5 GHz\n5 spatial streams",
  "u7lite.description": "Compact WiFi 7",
  "u7lite.dimensions": "Ø171.5 x 33 mm\n(Ø6.8 x 1.3\")",
  "u7lite.wifiTechnology": "WiFi 7\nDual-radio 2.4 / 5 GHz\n4 spatial streams",
  "u7outdoor.antennaType": "Directional\nOmnidirectional",
  "u7outdoor.antennaType.1": "Directional\nOmnidirectional*",
  "u7outdoor.description": "Integrated directional super antenna for long-range coverage",
  "u7outdoor.notes.antennaType": "*Includes optional, external omni antennas.",
  "u7outdoor.wifiCoverage": "Directional: 465 m² (5,000 ft²) open space\nOmnidirectional: 160 m² (1,750 ft²)",
  "u7outdoor.wifiTechnology": "WiFi 7\nDual-radio 2.4 / 5 GHz\n4 spatial streams",
  "u7pro.description.1": "WiFi 7 AP with 6 streams, 6 GHz for large spaces",
  "u7pro.dimensions": "Ø206 x 46 mm\n(Ø8.1 x 1.8\")",
  "u7pro.wifiTechnology": "WiFi 7\nTri-radio 2.4 / 5 / 6 GHz\n6 spatial streams",
  "u7proMax.description.1": "High-density WiFi 7",
  "u7proMax.dimensions": "Ø206 x 46 mm\n(Ø8.1 x 1.8\")",
  "u7proMax.wifiTechnology": "WiFi 7\nTri-radio 2.4 / 5 / 6 GHz\n8 spatial streams",
  "u7proOutdoor.antennaType": "Directional\nOmnidirectional",
  "u7proOutdoor.antennaType.1": "Directional\nOmnidirectional**",
  "u7proOutdoor.description": "Outdoor rugged IP67 design with extended-range AFC 6 GHz support",
  "u7proOutdoor.notes.1": "*US & CA version only.",
  "u7proOutdoor.notes.2": "**Includes optional, external omni antennas.",
  "u7proOutdoor.wifiCoverage": "Directional: 465 m² (5,000 ft²) open space\nOmnidirectional: 160 m² (1,750 ft²)",
  "u7proOutdoor.wifiTechnology": "WiFi 7\nTri-radio 2.4 / 5 / 6* GHz\n6 spatial streams",
  "u7proWall.customization": "With Paintable Flush Mount accessory",
  "u7proWall.description.1": "WiFi 7 and 6 GHz, tailored for interiors.",
  "u7proWall.dimensions": "150 x 103 x 36 mm\n(5.9 x 4.1 x 1.4\")",
  "u7proWall.mounting": "Wall\nDesktop",
  "u7proWall.notes": "*With optional Table Stand accessory.",
  "u7proWall.wifiTechnology": "WiFi 7\nTri-radio 2.4 / 5 / 6 GHz\n6 spatial streams",
  "u7proXg.description": "10G, 6-stream WiFi 7 AP",
  "u7proXg.dimensions": "Ø206 x 32.5 mm\n(Ø8.1 x 1.3\")",
  "u7proXg.wifiTechnology": "WiFi 7\nTri-radio 2.4 / 5 / 6 GHz\n6 spatial streams",
  "u7proXgs.description": "10G, 8-stream WiFi 7 AP",
  "u7proXgs.dimensions": "Ø215 x 32.5 mm\n(Ø8.5 x 1.3\")",
  "u7proXgs.wifiTechnology": "WiFi 7\nTri-radio 2.4 / 5 / 6 GHz\n8 spatial streams",
  "uaUltra.description": "Integrated hub and reader for single-door entry control",
  "uaUltra.inputTerminal": "(1) Request to exit\n(1) Tamper switch",
  "uaUltra.outdoorReady": "IP55 rain resistance (-30° to 45° C)",
  "uaUltra.outputRelays": "(1) Lock terminal (12V/1A)",
  "ucCast.connectivity": "Ethernet",
  "ucCast.deployment": "Pair with HDMI display",
  "ucCast.description": "Instantly transform any TV display into a managed digital signage device",
  "ucCast.powerMethod": "PoE\nUSB-C",
  "ucCast.title": "Display Cast",
  "ucCast.videoContentSupport": "Up to 4K / 30 FPS",
  "ucCastLite.deployment": "Pair with HDMI display",
  "ucCastLite.description": "Instantly transform any TV display into a managed digital signage device",
  "ucCastLite.dimensions": "Without mount:\n90 x 52 x 31 mm (3.5 x 2.1 x 1.2\")\nWith mount:\n92.1 x 56.3 x 40.8 mm (3.6 x 2.1 x 1.4\")",
  "ucCastLite.note": "*With UACC-Adapter-PoE-USBC, sold separately",
  "ucCastLite.powerMethodPoE": "USB-C\nPoE*",
  "ucCastLite.videoContentSupport": "Up to Full HD / 60 FPS",
  "ucCastLite.wiFiEthernet": "WiFi\nEthernet*",
  "ucCastPro.connectivity": "UniFi WiFi Auto-Link\nEthernet",
  "ucCastPro.deployment": "Pair with HDMI display",
  "ucCastPro.description": "Enhanced content playback, USB-C peripheral support, and UniFi WiFi Auto-Link",
  "ucCastPro.dimensions": "Without mount:\n123 x 52 x 31 mm (3.5 x 2.1 x 1.2\")\nWith mount:\n125.1 x 56.3 x 40.8 mm (3.6 x 2.1 x 1.4\")",
  "ucCastPro.powerMethod": "PoE\nUSB-C",
  "ucCastPro.videoContentSupport": "Up to 4K / 60 FPS",
  "ucCastProEn.title": "Display Cast Pro",
  "ucgFiber.description": "Desktop 10G Cloud Gateway with integrated PoE switch",
  "ucgFiber.lanPorts": "(1) 10G SFP+\n(4) 2.5 GbE RJ45 including (1) PoE+",
  "ucgFiber.note.1": "*Third-party SSD installation requires tray accessory.",
  "ucgFiber.storage": "Selectable NVMe SSD storage\nup to 2 TB for NVR",
  "ucgFiber.wanPorts": "(1) 10G SFP+\n(1) 10 GbE RJ45",
  "ucgMax.description": "The complete UniFi experience for small-to-medium sites",
  "ucgMax.idsIpsThroughput": "1.5 Gbps",
  "ucgMax.lanPorts": "(4) 2.5 GbE RJ45\nincluding (1) remappable to WAN",
  "ucgMax.mounting": "Desktop\nWall**",
  "ucgMax.note.accessory": "*With Floating Mount accessory.",
  "ucgMax.note1": "*Compatible with a UniFi 1TB or 2TB SSD Module.",
  "ucgMax.note2": "**With Floating Mount accessory.",
  "ucgMax.storage": "Selectable NVMe SSD storage\nup to 2 TB for NVR",
  "ucgMax.storage.1": "Selectable NVMe SSD storage\nup to 2 TB for NVR*",
  "ucgMax.throughput": "2.5 Gbps",
  "ucgMax.wanPorts": "(1) 2.5 GbE RJ45",
  "ucgUltra.description": "Ideal for small-to-medium networks",
  "ucgUltra.lanPorts": "(4) GbE RJ45\nincluding (1) remappable to WAN",
  "ucgUltra.wanPorts": "(1) 2.5 GbE RJ45",
  "udb.alignment": "Built-in LED indicators",
  "udb.description": "Wireless bridging PoE adapter",
  "udb.maximumRange": "300 m (984 ft)",
  "udb.throughput": "Up to 867 Mbps",
  "udb.uplink": "(1) GbE",
  "udbPro.alignment": "Built-in LED indicators",
  "udbPro.description": "5+ km distances or seamlessly uplinks to UniFi WiFi",
  "udbPro.maximumRange": "5+ km (3.1 mi)",
  "udbPro.note": "*PoE adapter included. PoE+ input required for PoE passthrough.",
  "udbPro.throughput": "Up to 867 Mbps",
  "udbPro.uplink": "(2) GbE with (1) PoE output",
  "udbProSector.description": "5 GHz point-to-multipoint AP that wirelessly bridges 50+ Device Bridge Pro",
  "udbProSector.maximumRange": "5+ km (3.1 mi)",
  "udbProSector.throughput": "Up to 400 Mbps",
  "udmPro.clientDevices": "1,000+",
  "udmPro.customDescription": "Great for large-scale deployments",
  "udmPro.description": "Professional-grade gateway firewall that runs the full UniFi application suite",
  "udmPro.generalRedundancy": "Shadow Mode (VRRP) Gateway Failover\nDC Power Backup*",
  "udmPro.generalRedundancy.note": "*Enable DC power backup using UniFi RPS",
  "udmPro.idsIpsThroughput": "3.5 Gbps",
  "udmPro.lanPorts": "(1) 10G SFP+\n(8) GbE RJ45",
  "udmPro.storage": "3.5\" NVR HDD bay",
  "udmPro.wanPorts": "(1) 10G SFP+\n(1) GbE RJ45",
  "udmProMax.clientDevices": "2,000+",
  "udmProMax.customDescription": "Double the capacity of Dream Machine Pro/SE",
  "udmProMax.description": "The most powerful Dream Machine yet, feature complete and redesigned for scale",
  "udmProMax.generalRedundancy": "Shadow Mode (VRRP) Gateway Failover\nDC Power Backup**",
  "udmProMax.generalRedundancy.note": "**Enable DC power backup using UniFi RPS",
  "udmProMax.idsIpsThroughput": "5 Gbps",
  "udmProMax.lanPorts": "(1) 10G SFP+\n(8) GbE RJ45",
  "udmProMax.note": "*With RAID data protection.",
  "udmProMax.storage": "(2) 3.5\" NVR HDD bays*\n128 GB SSD for detection recordings",
  "udmProMax.wanPorts": "(1) 10G SFP+\n(1) 2.5 GbE RJ45",
  "udmProSpecial.clientDevices": "1,000+",
  "udmProSpecial.customDescription": "Enhanced with integrated PoE switching",
  "udmProSpecial.description": "Enhanced with integrated PoE switching and 2.5 GbE RJ45 WAN",
  "udmProSpecial.generalRedundancy": "Shadow Mode (VRRP) Gateway Failover\nDC Power Backup*",
  "udmProSpecial.generalRedundancy.note": "*Enable DC power backup using UniFi RPS",
  "udmProSpecial.idsIpsThroughput": "3.5 Gbps",
  "udmProSpecial.lanPorts": "(1) 10G SFP+\n(8) GbE RJ45 including (2) PoE+ and (6) PoE",
  "udmProSpecial.storage": "3.5\" NVR HDD bay\n128 GB SSD for detection recordings",
  "udmProSpecial.title": "Dream Machine Special Edition",
  "udmProSpecial.wanPorts": "(1) 10G SFP+\n(1) 2.5 GbE RJ45",
  "udr.description": "WiFi integrated for small deployments",
  "udr.integratedWiFi": "Built-in WiFi 6 access point",
  "udr.lanPorts": "(4) GbE RJ45 including\n(2) PoE",
  "udr.storage": "NVR microSD card slot\n128 GB SSD for detection recordings",
  "udr.unifiAppSuite": "two applications",
  "udr.wanPorts": "(1) GbE RJ45",
  "udr7.description": "10G Cloud Gateway with integrated WiFi 7, PoE switch",
  "udr7.integratedWiFi": "Built-in WiFi 7 access point with 6 GHz support",
  "udr7.lanPorts": "(4) GbE RJ45 including (1) PoE",
  "udr7.storage": "Pre-installed 64GB microSD for NVR",
  "udr7.wanPorts": "(1) 10G SFP+\n(1) 2.5 GbE RJ45",
  "udw.clientDevices": "1,000+",
  "udw.description": "Designed for limited space",
  "udw.generalRedundancy": "(2) Hot-Swappable PSUs",
  "udw.idsIpsThroughput": "3.5 Gbps",
  "udw.integratedWiFi": "Built-in WiFi 6 access point",
  "udw.lanPorts": "(1) 10G SFP+\n(17) GbE RJ45 including (4) PoE++, (4) PoE+, and (4) PoE",
  "udw.mounting": "Wall",
  "udw.notes": "*Requires add-on,\nsecondary Power Module.",
  "udw.powerRedundancy": "Integrated redundant power supply system*",
  "udw.storage": "512 GB NVR microSD card\n128 GB SSD for detection recordings",
  "udw.wanPorts": "(1) 10G SFP+\n(1) 2.5 GbE RJ45",
  "uispBox.title": "Compatible with UISP-Box",
  "uispCoverage.title": "Coverage",
  "uispHorn.dimensions": "282 x 224 x 380 mm",
  "uispHorn.frequency": "5.15 - 6.875 GHz",
  "uispHorn.radiusCoverage": "30°",
  "uispHorn.weight": "Device: 3.06 kg\nMount: 925 g",
  "uispHorn.windLoading": "90 N @ 200 km/h",
  "uispPower.customBadge": "Up to 200W",
  "uispPower.dcPowerOutput": "Up to 200W",
  "uispPower.description": "Uninterruptible power system\ndesigned for MicroPoP applications.",
  "uispPower.internalBatterySupport": "115.92 Wh",
  "uispPower.mountType": "Wall",
  "uispPower.notes": "*With (2) PSUs installed (sold separately).",
  "uispPower.powerTransportOutput": "1 port",
  "uispPowerPro.customBadge": "Up to 480W",
  "uispPowerPro.dcPowerOutput": "Up to 480W",
  "uispPowerPro.description": "Designed to support high-capacity\nWISP deployment sites",
  "uispPowerPro.mountType": "1U Rack",
  "uispPowerPro.notes": "*With (2) power supplies installed.",
  "uispPowerPro.powerTransportOutput": "3 ports",
  "uispRouter.customBadge": "Compact PoE",
  "uispRouter.description": "Gigabit PoE router designed for MicroPoP applications",
  "uispRouterPro.customBadge": "Hi-Capacity Ethernet",
  "uispRouterPro.description": "10 GbE router designed\nfor ISP applications",
  "uispSwitch.customBadge": "Compact PoE",
  "uispSwitch.description": "Gigabit PoE switch designed for MicroPoP applications",
  "uispSwitch.mountType": "Desk, wall",
  "uispSwitch.networkingInterface": "(8) GbE RJ45 ports",
  "uispSwitch.notes": "*When enclosed in the UISP Box (sold separately).",
  "uispSwitch.poeAvailability": "110W (27V) total PoE availability",
  "uispSwitch.poeOutput": "(8) PoE (27V passive) RJ45 ports",
  "uispSwitchPlus.customBadge": "Hi-Capacity Ethernet",
  "uispSwitchPlus.description": "2.5 GbE PoE switch for ISP applications",
  "uispSwitchPlus.mountType": "Desk, wall, 1U rack",
  "uispSwitchPlus.networkingInterface": "(4) 2.5 GbE RJ45 ports",
  "uispSwitchPlus.notes": "*When enclosed in the UISP Box Plus (sold separately).",
  "uispSwitchPlus.poeAvailability": "160W (27V) total PoE availability",
  "uispSwitchPlus.poeOutput": "(4) PoE (27V passive) RJ45 ports",
  "uispSwitchPlus.powerRedundancy": "(1) Power TransPort™ input",
  "uispSwitchPro.customBadge": "Hi-Power Deployment",
  "uispSwitchPro.description": "220W (27V) PoE switch for ISP applications",
  "uispSwitchPro.mountType": "1U rack",
  "uispSwitchPro.networkingInterface": "(24) GbE RJ45 ports",
  "uispSwitchPro.poeAvailability": "220W (27V) total PoE availability",
  "uispSwitchPro.poeOutput": "(16) PoE (27V passive) RJ45 ports",
  "uispSwitchPro.powerRedundancy": "(1) Power TransPort™ input",
  "umr.carrierSupport": "US: AT&T\nRest of World: Unlocked",
  "umr.description": "Indoor mobile WiFi router for plug-and-play connectivity",
  "umr.mounting": "Wall\nDIN Rail\nDesktop",
  "umr.mounting.1": "Wall\nDIN Rail\nDesktop**",
  "umr.networkingInterfaces": "(2) GbE RJ45 with (1) PoE output",
  "umr.networkingInterfaces.1": "(2) GbE RJ45 with (1) PoE output*",
  "umr.notes.accessory": "**With optional Table Stand accessory.",
  "umr.notes.poe": "*PoE+ input required for PoE passthrough.",
  "umr.powerMethod": "PoE/PoE+\nUSB Type-C\n4-Pin DC Power Socket (9V DC)",
  "umrIndustrial.carrierSupport": "Unlocked",
  "umrIndustrial.description": "Ruggedized mobile WiFi router for versatile indoor/outdoor deployment",
  "umrIndustrial.dimensions": "Without antennas and outdoor cover:\n114.5 x 93.6 x 32 mm (4.5 x 3.7 x 1.3\")\nWith antennas:\n213 x 93.6 x 32 mm (83 x 3.7 x 1.3\")\nWith antennas and outdoor cover:\n217 x 94 x 32 mm (8.5 x 3.7 x 1.3\")",
  "umrIndustrial.mounting": "Wall\nPole\nDIN Rail",
  "umrIndustrial.networkingInterfaces": "(2) GbE RJ45 with (1) PoE output",
  "umrIndustrial.networkingInterfaces.1": "(2) GbE RJ45 with (1) PoE output*",
  "umrIndustrial.notes.poe": "*PoE+ input required for PoE passthrough.",
  "umrIndustrial.outdoorReady": "With the included weatherproof cover",
  "umrIndustrial.powerMethod": "PoE/PoE+\nUSB Type-C\n4-Pin DC Power Socket (9—30V DC)",
  "umrUltra.carrierSupport": "Unlocked",
  "umrUltra.description": "Ultra-compact managed LTE mobile router for IoT applications",
  "umrUltra.dimensions": "Without antennas:\n84 x 82 x 26 mm (3.3 x 3.2 x 1\")\nWith antennas:\n193.5 x 82 x 26 mm (7.6 x 3.2 x 1\")",
  "umrUltra.mounting": "Wall\nDIN Rail",
  "umrUltra.networkingInterface": "(2) FE RJ45",
  "umrUltra.powerMethod": "USB Type-C\n4-Pin DC Power Socket (9—30V DC)",
  "unas.formFactor.compactDesktop": "Compact Desktop",
  "unas2.description": "Reimagined desktop NAS in a compact footprint",
  "unas2.powerMethod": "PoE++ / 60W PoE++ injector",
  "unas2.storageCapacity": "(2) 3.5\" HDD support",
  "unas4.comingSoon": "Shipping Q4 2025",
  "unas4.description": "Reimagined desktop NAS for multi-client performance",
  "unas4.powerMethod": "PoE+++ / 90W PoE+++ injector",
  "unas4.storageCapacity": "(4) 2.5/3.5\" HDD support\n(2) M.2 NVMe SSD support",
  "unasPro.description": "10G networking for large-scale file storage and sharing",
  "unasPro.formFactor": "2U rack-mountable",
  "unasPro.powerMethod": "(1) Universal AC input\n(1) USP-RPS DC input",
  "unasPro.powerRedundancy": "UniFi Power Backup ready",
  "unasPro.storageCapacity": "(7) 2.5/3.5\" HDD support",
  "unasPro4.comingSoon": "Shipping Q4 2025",
  "unasPro4.description": "10G networking for large-scale file storage and sharing",
  "unasPro4.formFactor": "1U rack-mountable",
  "unasPro4.powerMethod": "(1) Universal AC input\n(1) USP-RPS DC input",
  "unasPro4.storageCapacity": "(4) 2.5/3.5\" HDD support\n(2) M.2 NVMe SSD support",
  "unasPro8.comingSoon": "Shipping Oct 2025",
  "unasPro8.description": "10G networking for high availability deployments",
  "unasPro8.powerMethod": "(2) AC input, Hot-swappable power modules",
  "unasPro8.powerRedundancy": "(2) hot-swap PSUs for power redundancy",
  "unasPro8.storageCapacity": "(8) 2.5/3.5\" HDD support\n(2) M.2 NVMe SSD support",
  "unifiAppSuite.title": "UniFi Application Suite",
  "unifiDevices.title": "UniFi Devices",
  "unifiPowerBackup.title": "UniFi Power Backup",
  "unlock.title": "Lock terminals (12V and Dry)",
  "uplink.title": "Uplink",
  "uplinkSpeed.title": "Uplink Speed",
  "upsFunctionality.title": "UPS Functionality",
  "usbCPeripheralSupport.title": "USB-C Peripheral Support",
  "vantagePoint.title": "Vantage Point",
  "vantagePoint.tooltip": "Combine multiple NVRs together, independent of their physical location, for a consolidated UniFi Protect management experience.",
  "videoContentSupport.title": "Video Content Support",
  "videoContentSupport.tooltip": "Use the recommended encoding settings when exporting digital signage video files to ensure an optimal experience. <a href=\"https://help.ui.com/hc/en-us/articles/15670911603223-UniFi-Connect-Video-Content-Best-Practices\">Learn more.</a>",
  "wanPorts.title": "WAN Ports",
  "wanSwitch.description": "10G SFP+ WAN Switch linking two UniFi Gateways in Shadow Mode to one ISP.",
  "wanSwitch.powerRedundancy": "(2) AC inputs",
  "wanSwitchRj45.comingSoonButtonText": "Available May 2025",
  "wanSwitchRj45.description": "10 GbE WAN Switch linking two UniFi Gateways in Shadow Mode to one ISP.",
  "wanSwitchRj45.powerRedundancy": "(2) AC inputs",
  "waterproof.title": "Outdoor-Ready",
  "waveAp.description": "60 GHz long-range PtMP access point powered by Wave Technology",
  "waveAp.notes.1": "*Supported with version 3.4.0 and later.",
  "waveAp.notes.2": "**Max. throughput: 800 Mbps",
  "waveApGen2.description": "Gen2 60 GHz PtMP wide-coverage access point powered by Wave Technology",
  "waveApMicro.description": "Wide-coverage 60 GHz PtMP access point powered by Wave Technology",
  "waveApMicro.notes.1": "*Supported with version 3.4.0 and later.",
  "waveApMicro.notes.2": "**Max. throughput: 800 Mbps",
  "waveFiberOlt.description": "A compact single-port optical line terminal with an XGS/GPON combo port that can deliver up to 10 Gbps speeds.",
  "waveFiberOlt.notes.1": "*Symmetrical upstream/downstream.",
  "waveFiberOnu.description": "Compact with 2.5 GbE and an LED display",
  "waveLongRange.description": "60 GHz PtMP & PtP station powered by Wave Technology",
  "waveLongRange.notes.1": "*Supported with version 3.3.0 and later.",
  "waveLongRange.notes.2": "**Max. throughput: 800 Mbps",
  "waveMLO5.description": "Hi-performance dual 5 GHz WiFi 7-based radio with MLO technology for long-range integrations.",
  "waveMLO6.description": "Hi-performance 5-7 GHz WiFi 7-based radio with MLO technology for long-range integrations.",
  "waveNano.description": "Compact 60 GHz PtMP & PtP station",
  "waveNano.notes.1": "*Supported with version 3.3.0 and later.",
  "waveNano.notes.2": "**Max. throughput: 800 Mbps",
  "wavePico.description": "Lightweight, compact 60 GHz PtMP & PtP station",
  "wavePico.notes.1": "*Supported with version 3.3.0 and later.",
  "wavePico.notes.2": "**Max. throughput: 800 Mbps",
  "wavePro.description": "High-capacity, long-distance PtP (bridge) and PtMP links",
  "wavePro.notes.1": "*Max. throughput: 800 Mbps",
  "waveTechnology.title": "Wave Technology",
  "weatherproofing.title": "Weatherproofing",
  "webMode.title": "Web Mode",
  "weight.title": "Weight",
  "wifi.title": "WiFi",
  "wifi6Technology.title": "WiFi Technology",
  "wifiIntegrated.title": "WiFi Integrated",
  "wifiMounting.title": "Mounting",
  "wifiPowerMethod.title": "Power Method",
  "wifiTechnology.title": "WiFi Technology",
  "windLoading.title": "Wind Loading",
  "wirelessHandsetSupport.label": "Wireless Handset Support",
  "wirelessHandsetSupport.tooltip": "<a href=\"https://store.ui.com/category/managed-voip/products/ut-g3-handset?variant=ut-g3-handset\" target=\"_blank\"><span style=\"color: #006FFF\">G3 Wireless Handset</span></a> sold separately.",
  "wirelessHeadsetSupport.label": "Wireless Headset Support",
  "xg6PoEGen1.description": "Layer 2 switch with a silent, fanless cooling system",
  "xg6PoEGen1.powerRedundancy": "Wired DC backup power ready",
  "xgsxg.bridge": "Bridge only",
  "xgsxg.description": "10 Gbps optical\ntransceiver module",
  "xgsxg.maxLinkRange": "20 km",
  "xgsxg.networkingInterface": "(1) SC/UPC",
  "xgsxg.powerMethod": "SFP",
  "youtubeMode.title": "YouTube Mode",
  "youtubeMode.tooltip": "Seamlessly stream YouTube videos and playlists. <a href=\"https://help.ui.com/hc/en-us/articles/19545148603031-UniFi-Connect-Stream-YouTube-Content-to-Displays\">Learn more.</a>"
};
export { New, EN_TRANSLATION as default };
//# sourceMappingURL=en.json.mjs.map
